(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ketfii-blogs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ketfii-journal')) {
  customElements.define('ketfii-journal', class extends HTMLElement {
    connectedCallback() {
      this.cancel = new AbortController();
      this.track = this.querySelector('[data-kj-track]');
      if (!this.track) return;

      this.cards = Array.from(this.querySelectorAll('[data-kj-card]'));
      this.controls = this.querySelector('[data-kj-controls]');
      this.prev = this.querySelector('[data-kj-prev]');
      this.next = this.querySelector('[data-kj-next]');
      this.toggle = this.querySelector('[data-kj-toggle]');
      this.counter = this.querySelector('[data-kj-counter]');
      this.status = this.querySelector('[data-kj-status]');
      this.media = window.matchMedia('(max-width: 749px)');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.motion.matches || this.dataset.editor === 'true';
      this.inView = false;
      this.hovered = false;
      this.focused = false;
      this.blockSelected = false;

      const on = (target, event, fn, options = {}) =>
        target?.addEventListener(event, fn, {
          ...options,
          signal: this.cancel.signal
        });

      on(this.prev, 'click', () => {
        this.pause();
        this.move(-1, true);
      });

      on(this.next, 'click', () => {
        this.pause();
        this.move(1, true);
      });

      on(this.toggle, 'click', () => {
        this.userPaused = !this.userPaused;
        this.syncToggle();
        this.schedule();
      });

      on(this.track, 'scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.update());
      }, { passive: true });

      on(this.track, 'pointerdown', () => this.pause(), { passive: true });
      on(this.track, 'wheel', () => this.pause(), { passive: true });

      on(this.track, 'keydown', event => {
        if (event.target !== this.track || !this.carousel) return;

        const rtl = getComputedStyle(this).direction === 'rtl';

        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.pause();
          this.move(
            (event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1),
            true
          );
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.pause();
          this.go(
            event.key === 'Home' ? 0 : this.visibleCards.length - 1,
            true
          );
        }
      });

      on(this, 'pointerenter', event => {
        if (event.pointerType === 'mouse') {
          this.hovered = true;
          this.schedule();
        }
      });

      on(this, 'pointerleave', () => {
        this.hovered = false;
        this.schedule();
      });

      on(this, 'focusin', () => {
        this.focused = true;
        this.schedule();
      });

      on(this, 'focusout', () => {
        queueMicrotask(() => {
          if (this.isConnected) {
            this.focused = this.contains(document.activeElement);
            this.schedule();
          }
        });
      });

      on(document, 'visibilitychange', () => this.schedule());
      on(this.media, 'change', () => this.refresh());

      on(this.motion, 'change', () => {
        if (this.motion.matches) this.pause();
        this.refresh();
      });

      on(document, 'shopify:block:select', event => {
        const card = this.cards.find(item =>
          item.dataset.blockId &&
          item.dataset.blockId === event.detail?.blockId
        );

        if (!card) return;

        this.blockSelected = true;
        this.applyFilter('');
        this.refresh();
        this.go(this.visibleCards.indexOf(card), false);
        this.schedule();
      });

      on(document, 'shopify:block:deselect', () => {
        this.blockSelected = false;
        this.schedule();
      });

      this.buildFilters(on);

      this.resizeObserver = new ResizeObserver(() => this.refresh());
      this.resizeObserver.observe(this.track);

      if ('IntersectionObserver' in window) {
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.inView = entries.some(entry => entry.isIntersecting);
          this.schedule();
        }, { threshold: 0.1 });

        this.intersectionObserver.observe(this);
      } else {
        this.inView = true;
      }

      this.refresh();
    }

    disconnectedCallback() {
      this.cancel?.abort();
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      clearTimeout(this.timer);
      cancelAnimationFrame(this.scrollFrame);
    }

    buildFilters(on) {
      const holder = this.querySelector('[data-kj-filters]');
      if (!holder) return;

      holder.replaceChildren();

      const categories = [
        ...new Set(
          this.cards.map(card => card.dataset.category).filter(Boolean)
        )
      ];

      if (categories.length < 2) {
        holder.hidden = true;
        return;
      }

      ['', ...categories].forEach(category => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'kj__filter';
        button.dataset.category = category;
        button.textContent = category || this.dataset.allLabel;
        button.setAttribute(
          'aria-pressed',
          category === '' ? 'true' : 'false'
        );

        on(button, 'click', () => {
          this.pause();
          this.applyFilter(category);
        });

        holder.append(button);
      });

      holder.hidden = false;
    }

    applyFilter(category) {
      this.cards.forEach(card => {
        card.hidden = !!category && card.dataset.category !== category;
      });

      this.querySelectorAll('.kj__filter').forEach(button => {
        button.setAttribute(
          'aria-pressed',
          String(button.dataset.category === category)
        );
      });

      this.track.scrollTo({ left: 0, behavior: 'instant' });
      this.refresh();
      this.announce();
    }

    refresh() {
      this.visibleCards = this.cards.filter(card => !card.hidden);

      this.cards.forEach(card => {
        card.removeAttribute('data-first-visible');
      });

      this.visibleCards[0]?.setAttribute('data-first-visible', '');

      this.carousel = (
        this.media.matches ? this.dataset.mobile : this.dataset.desktop
      ) === 'carousel';

      if (!this.carousel) this.track.scrollLeft = 0;

      this.overflow =
        this.carousel &&
        this.track.scrollWidth > this.track.clientWidth + 4;

      this.controls.hidden = !this.overflow;
      this.track.tabIndex = this.overflow ? 0 : -1;

      this.update();
      this.syncToggle();
      this.schedule();
    }

    update() {
      const box = this.track.getBoundingClientRect();
      const rtl = getComputedStyle(this).direction === 'rtl';
      const max = Math.max(
        0,
        this.track.scrollWidth - this.track.clientWidth
      );
      const offset = Math.min(max, Math.abs(this.track.scrollLeft));

      const shown = this.visibleCards.filter(card => {
        const rect = card.getBoundingClientRect();

        return (
          rect.right > box.left + Math.min(25, rect.width / 2) &&
          rect.left < box.right - Math.min(25, rect.width / 2)
        );
      });

      let nearest = 0;
      let distance = Infinity;

      this.visibleCards.forEach((card, index) => {
        const rect = card.getBoundingClientRect();
        const delta = Math.abs(
          rtl ? box.right - rect.right : rect.left - box.left
        );

        if (delta < distance) {
          nearest = index;
          distance = delta;
        }
      });

      this.index = nearest;
      this.atStart = offset < 4;
      this.atEnd = offset >= max - 4;

      if (this.prev) {
        this.prev.disabled =
          this.dataset.loop !== 'true' && this.atStart;
      }

      if (this.next) {
        this.next.disabled =
          this.dataset.loop !== 'true' && this.atEnd;
      }

      const start = shown.length
        ? this.visibleCards.indexOf(shown[0]) + 1
        : nearest + 1;

      const end = shown.length
        ? this.visibleCards.indexOf(shown[shown.length - 1]) + 1
        : start;

      if (this.counter) {
        this.counter.textContent =
          `${start === end ? start : `${start}–${end}`} / ${this.visibleCards.length}`;
      }

      this.style.setProperty(
        '--kj-progress',
        String(
          max
            ? (offset + this.track.clientWidth) / this.track.scrollWidth
            : 1
        )
      );
    }

    go(index, announce) {
      const card = this.visibleCards[
        Math.max(0, Math.min(index, this.visibleCards.length - 1))
      ];

      if (!card || !this.carousel) return;

      const box = this.track.getBoundingClientRect();
      const rect = card.getBoundingClientRect();
      const rtl = getComputedStyle(this).direction === 'rtl';
      const delta = rtl
        ? rect.right - box.right
        : rect.left - box.left;

      this.track.scrollBy({
        left: delta,
        behavior: this.motion.matches ? 'instant' : 'smooth'
      });

      if (announce) {
        this.status.textContent =
          `${Math.max(0, index) + 1} / ${this.visibleCards.length}`;
      }
    }

    move(direction, announce) {
      this.update();

      let next = this.index + direction;

      if (direction > 0 && this.atEnd) {
        if (this.dataset.loop !== 'true') return;
        next = 0;
      }

      if (direction < 0 && this.atStart) {
        if (this.dataset.loop !== 'true') return;
        next = this.visibleCards.length - 1;
      }

      this.go(next, announce);
    }

    announce() {
      this.status.textContent =
        `${this.visibleCards.length} ${this.dataset.countLabel}`;
    }

    pause() {
      this.userPaused = true;
      this.syncToggle();
      clearTimeout(this.timer);
    }

    syncToggle() {
      if (!this.toggle) return;

      this.toggle.setAttribute(
        'aria-pressed',
        String(this.userPaused)
      );

      this.toggle.setAttribute(
        'aria-label',
        this.userPaused
          ? this.dataset.playLabel
          : this.dataset.pauseLabel
      );

      this.toggle
        .querySelector('[data-kj-play-icon]')
        .toggleAttribute('hidden', !this.userPaused);

      this.toggle
        .querySelector('[data-kj-pause-icon]')
        .toggleAttribute('hidden', this.userPaused);
    }

    schedule() {
      clearTimeout(this.timer);

      if (
        !this.isConnected ||
        this.dataset.autoplay !== 'true' ||
        !this.overflow ||
        this.userPaused ||
        this.motion.matches ||
        !this.inView ||
        this.hovered ||
        this.focused ||
        this.blockSelected ||
        document.hidden ||
        this.dataset.editor === 'true'
      ) return;

      if (this.atEnd && this.dataset.loop !== 'true') return;

      this.timer = setTimeout(() => {
        this.move(1, false);
        this.schedule();
      }, Math.max(3000, Number(this.dataset.delay) || 6000));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ketfii-cinema-banner"] && !Shopify.designMode) return;
  try {
    
/* Vanilla custom element. Every listener, timer and observer belongs to one instance. */
if (!customElements.get('ketfii-cinema-banner')) {
  customElements.define('ketfii-cinema-banner', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.controller) return;
        this.controller = new AbortController();
        this.slides = [...this.querySelectorAll('.kb-slide')];
        if (!this.slides.length) return;
        this.dots = [...this.querySelectorAll('.kb-dot')];
        this.index = 0;
        this.timer = null;
        this.deadline = 0;
        this.remaining = this.intervalFor(0);
        this.pauses = new Set();
        this.mediaPaused = new Set();
        this.mediaAllowed = new Set();
        this.mediaFailed = new WeakSet();
        this.mobileQuery = matchMedia('(max-width: 749px)');
        this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
        this.editor = Boolean(window.Shopify && window.Shopify.designMode);
        this.userMotion = false;
        this.soundOn = false;
        this.activation = 0;
        this.listen(this, 'click', e => this.onClick(e));
        this.listen(this, 'keydown', e => this.onKey(e));
        this.listen(this, 'focusin', e => this.setPause('focus', !e.target.closest('[data-action="rotation"], [data-action="video"], [data-action="sound"]')));
        this.listen(this, 'focusout', () => queueMicrotask(() => {
          if (this.isConnected && !this.contains(document.activeElement)) this.setPause('focus', false);
        }));
        if (this.dataset.hoverPause === 'true') {
          this.listen(this, 'pointerenter', e => { if (e.pointerType === 'mouse') this.setPause('hover', true); });
          this.listen(this, 'pointerleave', e => { if (e.pointerType === 'mouse') this.setPause('hover', false); });
        }
        this.listen(document, 'visibilitychange', () => this.setPause('document', document.hidden));
        this.listen(this.mobileQuery, 'change', () => { this.stopClock(); this.activateMedia(true); this.measureHeader(); });
        this.listen(this.motionQuery, 'change', () => { this.userMotion = false; this.stopClock(); this.activateMedia(false); });
        this.listen(window, 'resize', () => this.measureHeader());
        this.listen(document, 'shopify:block:select', e => {
          const i = this.slides.findIndex(slide => slide.dataset.blockId === String(e.detail?.blockId));
          if (i >= 0 && (!e.detail?.sectionId || String(e.detail.sectionId) === this.dataset.sectionId)) {
            this.editor = true;
            this.goTo(i, true);
          }
        });
        this.listen(document, 'shopify:section:load', () => this.measureHeader());
        this.listen(document, 'shopify:section:reorder', () => this.measureHeader());
        if (this.dataset.swipe === 'true') this.bindSwipe();
        this.querySelectorAll('video').forEach(video => {
          this.listen(video, 'playing', () => {
            if (video !== this.currentVideo || this.shouldPauseMedia(video)) { video.pause(); return; }
            video.classList.add('is-ready');
            this.mediaFailed.delete(video);
            this.updateControls();
          });
          this.listen(video, 'pause', () => this.updateControls());
          this.listen(video, 'loadedmetadata', () => {
            if (video === this.currentVideo && this.dataset.videoAdvance === 'end') this.armClock();
          });
          this.listen(video, 'ended', () => {
            if (video !== this.currentVideo) return;
            if (this.dataset.videoAdvance === 'end' && this.canRotate()) this.goTo(this.index + 1, false);
            else this.updateControls();
          });
          this.listen(video, 'error', () => {
            this.mediaFailed.add(video);
            video.classList.remove('is-ready');
            if (video === this.currentVideo) {
              this.stopClock(); this.remaining = this.intervalFor(this.index);
              this.armClock(); this.updateControls();
            }
          });
        });
        this.observer = new IntersectionObserver(entries => {
          this.setPause('offscreen', !entries[0].isIntersecting);
        }, { threshold: 0.05 });
        this.observer.observe(this);
        this.resizeObserver = new ResizeObserver(() => this.measureHeader());
        const group = document.querySelector('#header-group');
        if (group) this.resizeObserver.observe(group);
        const header = document.querySelector('#header-component');
        if (header) this.resizeObserver.observe(header);
        this.cardObserver = new ResizeObserver(entries => {
          entries.forEach(entry => entry.target.closest('.kb-slide').style.setProperty('--kb-card-height', `${entry.target.offsetHeight}px`));
        });
        this.querySelectorAll('.kb-card').forEach(card => this.cardObserver.observe(card));
        this.pauses.add('offscreen');
        if (document.hidden) this.pauses.add('document');
        this.classList.add('is-initialized');
        this.measureHeader();
        this.goTo(0, false);
      });
    }

    listen(target, event, callback, options = {}) {
      target.addEventListener(event, callback, { ...options, signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.activation = (this.activation || 0) + 1;
      this.stopClock();
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.cardObserver?.disconnect();
      this.querySelectorAll('video').forEach(v => v.pause());
    }

    ensurePoster(slide) {
      if (!slide) return;
      slide.querySelectorAll('template[data-kb-poster]').forEach(template => {
        const content = template.content.cloneNode(true);
        content.querySelectorAll('img').forEach(image => {
          image.loading = 'eager';
          image.fetchPriority = 'low';
        });
        template.replaceWith(content);
      });
    }

    warmNextPoster() {
      if (!this.canRotate()) return;
      const active = this.slides[this.index];
      const mobile = this.mobileQuery.matches && active.dataset.mobileMedia !== 'inherit';
      const image = active.querySelector(`[data-device="${mobile ? 'mobile' : 'desktop'}"] .kb-poster img`);
      if (image && !image.complete) {
        this.posterTimer = setTimeout(() => this.warmNextPoster(), 500);
        return;
      }
      this.ensurePoster(this.slides[(this.index + 1) % this.slides.length]);
    }

    intervalFor(index) { return Number(this.slides[index]?.dataset.duration) || Number(this.dataset.interval) || 5000; }
    reduceMotion() { return this.motionQuery.matches && !this.userMotion; }
    canRotate() { return this.isConnected && this.dataset.autoplay === 'true' && this.slides.length > 1 && !this.editor && !this.pauses.size && !this.reduceMotion() && !this.mediaPaused.has(this.index); }
    stopClock() {
      clearTimeout(this.posterTimer);
      if (this.timer !== null && this.timer !== undefined) {
        this.remaining = Math.max(0, this.deadline - performance.now());
        clearTimeout(this.timer);
      }
      this.timer = null;
    }

    armClock() {
      this.stopClock();
      if (!this.canRotate()) return;
      let delay = this.remaining;
      const video = this.currentVideo;
      if (video && this.dataset.videoAdvance === 'end' && !this.mediaFailed.has(video) && this.slides[this.index].dataset.videoAutoplay === 'true') {
        delay = Number.isFinite(video.duration) ? Math.max(1000, (video.duration - video.currentTime) * 1000 + 1800) : Math.max(10000, this.intervalFor(this.index));
      }
      delay = Math.max(200, delay);
      this.posterTimer = setTimeout(() => this.warmNextPoster(), Math.max(1000, delay - 1600));
      this.deadline = performance.now() + delay;
      this.timer = setTimeout(() => { this.timer = null; if (this.canRotate()) this.goTo(this.index + 1, false); }, delay);
    }

    setPause(reason, pause) {
      const existed = this.pauses.has(reason);
      if (existed === pause) return;
      this.stopClock();
      if (pause) this.pauses.add(reason); else this.pauses.delete(reason);
      this.syncMedia();
      this.armClock();
      this.updateControls();
    }

    goTo(requested, user) {
      if (!this.slides.length) return;
      const next = (requested % this.slides.length + this.slides.length) % this.slides.length;
      const direction = requested < this.index ? -1 : 1;
      this.stopClock();
      this.ensurePoster(this.slides[next]);
      this.style.setProperty('--kb-slide-direction', direction);
      const focusedSlide = document.activeElement?.closest('.kb-slide');
      if (focusedSlide && focusedSlide !== this.slides[next]) this.focus({ preventScroll: true });
      this.slides.forEach((slide, i) => {
        const active = i === next;
        slide.classList.toggle('is-leaving', i === this.index && !active);
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      this.index = next;
      this.dataset.activeIndex = String(next);
      this.remaining = this.intervalFor(next);
      this.dots.forEach((dot, i) => { if (i === next) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      const count = this.querySelector('[data-current]');
      if (count) count.textContent = String(next + 1);
      if (user) this.querySelector('[data-status]').textContent = `${next + 1} / ${this.slides.length}: ${this.slides[next].dataset.title}`;
      this.activateMedia(true);
    }

    activateMedia(reset) {
      const slide = this.slides[this.index];
      const mobileLayer = this.mobileQuery.matches && slide.dataset.mobileMedia !== 'inherit';
      const layer = slide.querySelector(`[data-device="${mobileLayer ? 'mobile' : 'desktop'}"]`);
      const nextVideo = layer?.querySelector('video') || null;
      this.activation += 1;
      this.querySelectorAll('video').forEach(video => {
        if (video !== nextVideo) {
          video.pause(); video.muted = true;
          if (this.dataset.resetVideo === 'true' && video.readyState > 0) { try { video.currentTime = 0; } catch (_) {} }
        }
      });
      if (reset && nextVideo && nextVideo !== this.currentVideo && this.dataset.resetVideo === 'true' && nextVideo.readyState > 0) {
        try { nextVideo.currentTime = 0; } catch (_) {}
      }
      this.currentVideo = nextVideo;
      if (nextVideo) {
        // With one slide, or automatic slide rotation disabled, the background loops.
        nextVideo.loop = this.slides.length < 2 || this.dataset.autoplay !== 'true' || this.dataset.videoAdvance === 'timer' || this.editor;
        nextVideo.muted = !this.soundOn;
      }
      this.syncMedia();
      this.armClock();
      this.updateControls();
    }

    shouldPauseMedia(video) {
      const blocked = [...this.pauses].some(reason => reason !== 'focus');
      return !this.isConnected || blocked || this.mediaPaused.has(this.index) || this.reduceMotion() || (this.slides[this.index].dataset.videoAutoplay !== 'true' && !this.mediaAllowed.has(this.index));
    }

    syncMedia() {
      const video = this.currentVideo;
      if (!video) return;
      if (this.shouldPauseMedia(video)) { video.pause(); return; }
      if (this.mediaFailed.has(video)) return;
      if (video.ended && this.dataset.videoAdvance === 'end' && this.canRotate()) { this.goTo(this.index + 1, false); return; }
      if (!video.dataset.loaded) {
        video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
        video.dataset.loaded = 'true';
        video.load();
      }
      const activation = this.activation;
      const promise = video.play();
      if (promise) promise.then(() => {
        if (activation !== this.activation || video !== this.currentVideo || this.shouldPauseMedia(video)) {
          if (video !== this.currentVideo || this.shouldPauseMedia(video)) video.pause();
        }
      }).catch(() => {
        if (activation !== this.activation || video !== this.currentVideo || this.shouldPauseMedia(video)) return;
        this.mediaFailed.add(video);
        this.stopClock();
        this.remaining = this.intervalFor(this.index);
        this.updateControls();
        this.armClock();
      });
    }

    updateControls() {
      const rotation = this.querySelector('[data-action="rotation"]');
      if (rotation) {
        const paused = this.pauses.has('user') || this.reduceMotion();
        rotation.dataset.paused = String(paused);
        rotation.setAttribute('aria-pressed', String(paused));
        rotation.setAttribute('aria-label', paused ? rotation.dataset.playLabel : rotation.dataset.pauseLabel);
      }
      const videoButton = this.querySelector('[data-action="video"]');
      if (videoButton) {
        videoButton.hidden = !this.currentVideo;
        const paused = !this.currentVideo || this.currentVideo.paused;
        videoButton.dataset.paused = String(paused);
        videoButton.setAttribute('aria-label', paused ? videoButton.dataset.playLabel : videoButton.dataset.pauseLabel);
      }
      const sound = this.querySelector('[data-action="sound"]');
      if (sound) {
        sound.hidden = !this.currentVideo;
        sound.setAttribute('aria-pressed', String(this.soundOn));
        sound.setAttribute('aria-label', this.soundOn ? sound.dataset.muteLabel : sound.dataset.unmuteLabel);
      }
    }

    onClick(event) {
      if (performance.now() < (this.suppressClickUntil || 0)) { event.preventDefault(); event.stopPropagation(); return; }
      const button = event.target.closest('[data-action]');
      if (!button || !this.contains(button)) return;
      const action = button.dataset.action;
      if (action === 'next') this.goTo(this.index + 1, true);
      if (action === 'prev') this.goTo(this.index - 1, true);
      if (action === 'dot') this.goTo(Number(button.dataset.index), true);
      if (action === 'rotation') {
        if (this.reduceMotion() || this.pauses.has('user')) {
          this.userMotion = true;
          this.mediaPaused.delete(this.index);
          this.pauses.delete('focus');
          this.pauses.delete('hover');
          this.setPause('user', false);
          this.syncMedia(); this.armClock(); this.updateControls();
        } else this.setPause('user', true);
      }
      if (action === 'video' && this.currentVideo) {
        if (this.currentVideo.paused) {
          this.userMotion = true;
          this.mediaAllowed.add(this.index);
          this.mediaPaused.delete(this.index);
          this.pauses.delete('user'); this.pauses.delete('focus'); this.pauses.delete('hover');
          this.mediaFailed.delete(this.currentVideo);
          this.syncMedia(); this.armClock();
        } else {
          this.stopClock(); this.mediaPaused.add(this.index); this.currentVideo.pause();
        }
        this.updateControls();
      }
      if (action === 'sound' && this.currentVideo) {
        this.soundOn = !this.soundOn;
        this.currentVideo.muted = !this.soundOn;
        this.updateControls();
      }
    }

    onKey(event) {
      if (this.dataset.keyboard !== 'true' || this.slides.length < 2 || event.target.matches('input, textarea, select, [contenteditable="true"]')) return;
      let target;
      if (event.key === 'ArrowRight') target = this.index + 1;
      if (event.key === 'ArrowLeft') target = this.index - 1;
      if (event.key === 'Home') target = 0;
      if (event.key === 'End') target = this.slides.length - 1;
      if (target !== undefined) { event.preventDefault(); this.goTo(target, true); }
    }

    bindSwipe() {
      this.listen(this, 'pointerdown', event => {
        if (this.slides.length < 2 || !event.isPrimary || event.button !== 0 || event.target.closest('button, input, select, textarea')) return;
        this.gesture = { x: event.clientX, y: event.clientY, id: event.pointerId, active: false };
      });
      this.listen(this, 'pointermove', event => {
        const g = this.gesture;
        if (!g || g.id !== event.pointerId) return;
        const dx = event.clientX - g.x, dy = event.clientY - g.y;
        if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 12 && !g.active) { this.gesture = null; return; }
        if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          g.active = true;
          this.setPointerCapture(event.pointerId);
          this.classList.add('is-dragging');
          if (event.cancelable) event.preventDefault();
        }
      }, { passive: false });
      this.listen(this, 'pointerup', event => {
        const g = this.gesture;
        this.gesture = null;
        this.classList.remove('is-dragging');
        if (this.hasPointerCapture(event.pointerId)) this.releasePointerCapture(event.pointerId);
        if (!g || !g.active) return;
        const dx = event.clientX - g.x;
        this.suppressClickUntil = performance.now() + 350;
        if (Math.abs(dx) >= 40) this.goTo(this.index + (dx < 0 ? 1 : -1), true);
      });
      this.listen(this, 'pointercancel', () => { this.gesture = null; this.classList.remove('is-dragging'); });
    }

    measureHeader() {
      const section = this.closest('.shopify-section');
      const first = document.querySelector('main > .shopify-section');
      const header = document.querySelector('#header-component');
      const group = document.querySelector('#header-group');
      const isFirst = section === first;
      const overlay = Boolean(isFirst && header?.hasAttribute('transparent') && !header.closest('.header-section')?.nextElementSibling);
      const safe = this.dataset.headerSafe === 'true' && overlay ? header.offsetHeight : 0;
      const chrome = isFirst && group ? group.offsetHeight : 0;
      // Observe only the header, never the banner whose height these variables change.
      if (this.style.getPropertyValue('--kb-header-safe') !== `${safe}px`) this.style.setProperty('--kb-header-safe', `${safe}px`);
      if (this.style.getPropertyValue('--kb-chrome') !== `${chrome}px`) this.style.setProperty('--kb-chrome', `${chrome}px`);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ketfii-collection-coupons"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ketfii-collection-coupons')) {
  customElements.define('ketfii-collection-coupons', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.cards = Array.from(this.querySelectorAll('[data-coupon]'));
      this.resets = new Map();
      this.cards.forEach(card => {
        card._schedule = this.schedule(card);
        const copy = card.querySelector('[data-copy]');
        if (copy) copy.hidden = false;
      });
      this.addEventListener('click', event => {
        const copy = event.target.closest('[data-copy]');
        if (copy && !copy.disabled) this.copyCode(copy);
        const apply = event.target.closest('[data-apply]');
        if (apply && apply.getAttribute('aria-disabled') === 'true') event.preventDefault();
      }, {signal: this.controller.signal});
      document.addEventListener('visibilitychange', () => {
        clearTimeout(this.timer);
        if (!document.hidden) this.tick();
      }, {signal: this.controller.signal});
      if (this.dataset.editor === 'true') {
        document.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(card => card.dataset.shopifyEditorBlock && JSON.parse(card.dataset.shopifyEditorBlock).id === event.detail?.blockId);
          if (card) card.scrollIntoView({block: 'nearest', inline: 'nearest', behavior: 'instant'});
        }, {signal: this.controller.signal});
      }
      this.tick();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      clearTimeout(this.timer);
      this.resets?.forEach(timeout => clearTimeout(timeout));
    }
    schedule(card) {
      const parse = raw => {
        if (!raw) return null;
        if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(Z|[+-]\d{2}:\d{2})$/.test(raw.trim())) return NaN;
        return Date.parse(raw.trim());
      };
      const start = parse(card.dataset.start);
      const end = parse(card.dataset.end);
      const invalid = Number.isNaN(start) || Number.isNaN(end) || (start !== null && end !== null && end <= start);
      const warning = card.querySelector('[data-date-error]');
      if (warning) warning.hidden = !invalid;
      return {start, end, invalid};
    }
    tick() {
      if (!this.isConnected) return;
      const now = Date.now();
      let futureChange = false;
      let visible = 0;
      let nextBoundary = Infinity;
      this.cards.forEach(card => {
        const {start, end, invalid} = card._schedule;
        const state = invalid ? 'invalid' : end !== null && now >= end ? 'expired' : start !== null && now < start ? 'upcoming' : 'active';
        card.dataset.state = state;
        const hidden = (state === 'expired' && this.dataset.hideExpired === 'true') || (state === 'upcoming' && this.dataset.hideUpcoming === 'true');
        card.hidden = hidden && this.dataset.editor !== 'true';
        if (!card.hidden) visible++;
        const active = state === 'active';
        const copy = card.querySelector('[data-copy]');
        if (copy) copy.disabled = !active;
        const apply = card.querySelector('[data-apply]');
        if (apply) {
          if (active) {
            apply.href = apply.dataset.url;
            apply.removeAttribute('aria-disabled');
            apply.removeAttribute('tabindex');
          } else {
            apply.removeAttribute('href');
            apply.setAttribute('aria-disabled', 'true');
            apply.setAttribute('tabindex', '-1');
          }
        }
        const status = card.querySelector('[data-status]');
        if (status) {
          status.hidden = active || invalid;
          status.textContent = state === 'expired' ? this.dataset.ended : this.dataset.upcoming;
        }
        const target = state === 'upcoming' ? start : state === 'active' ? end : null;
        const timer = card.querySelector('[data-timer]');
        if (timer) {
          timer.hidden = target === null || invalid;
          if (!timer.hidden) {
            const prefix = timer.querySelector('[data-time-prefix]');
            const clock = timer.querySelector('[data-clock]');
            if (prefix) prefix.textContent = state === 'upcoming' ? this.dataset.starts : this.dataset.ends;
            if (clock) {
              clock.dateTime = state === 'upcoming' ? card.dataset.start : card.dataset.end;
              clock.textContent = this.formatTime(target - now);
            }
          }
        }
        if (!invalid) {
          [start, end].forEach(boundary => {
            if (boundary !== null && boundary > now) {
              futureChange = true;
              nextBoundary = Math.min(nextBoundary, boundary - now);
            }
          });
        }
      });
      this.hidden = visible === 0 && this.dataset.editor !== 'true';
      clearTimeout(this.timer);
      if (futureChange && !document.hidden) this.timer = setTimeout(() => this.tick(), Math.max(50, Math.min(nextBoundary, this.querySelector('[data-timer]:not([hidden])') ? 1000 : 15000)));
    }
    formatTime(ms) {
      const total = Math.max(0, Math.ceil(ms / 1000));
      const values = [Math.floor(total / 86400), Math.floor(total / 3600) % 24, Math.floor(total / 60) % 60, total % 60];
      const units = (this.dataset.units || 'd,h,m,s').split(',');
      return values.map((value, index) => String(value).padStart(2, '0') + (units[index]?.trim() || '')).join(' ');
    }
    async copyCode(button) {
      const card = button.closest('[data-coupon]');
      if (card.dataset.state !== 'active') return;
      const input = card.querySelector('[data-code]');
      const feedback = card.querySelector('[data-feedback]');
      if (!input || !feedback) return;
      let copied = false;
      try {
        if (navigator.clipboard?.writeText && window.isSecureContext) {
          await navigator.clipboard.writeText(input.value);
          copied = true;
        }
      } catch {}
      if (!copied) {
        input.focus({preventScroll: true});
        input.select();
        input.setSelectionRange(0, input.value.length);
        try { copied = document.execCommand('copy'); } catch {}
      }
      if (copied) button.focus({preventScroll: true});
      feedback.textContent = copied ? this.dataset.copySuccess : this.dataset.copyFailure;
      clearTimeout(this.resets.get(card));
      const reset = setTimeout(() => {
        if (this.isConnected) feedback.textContent = '';
        this.resets.delete(card);
      }, copied ? 3000 : 8000);
      this.resets.set(card, reset);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ketfii-food-moments"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ketfii-food-moments')) {
  customElements.define('ketfii-food-moments', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected && !this.controller) this.setup(); });
    }
    setup() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.removeClones();
      this.controller = new AbortController();
      const on = (element, name, fn, options = {}) => element?.addEventListener(name, fn, { ...options, signal:this.controller.signal });
      this.items = Array.from(this.querySelectorAll('[data-food]'));
      this.mobile = matchMedia('(max-width: 749px)');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.controls = this.querySelector('[data-controls]');
      this.nav = this.querySelector('[data-nav]');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.paused = false;
      this.inView = false;
      this.hovered = false;
      this.pointerHeld = false;
      this.holding = false;
      this.speed = Math.max(10, Math.min(80, Number(this.dataset.autoplaySpeed) || 25));
      on(this.previous, 'click', () => this.move(-1));
      on(this.next, 'click', () => this.move(1));
      on(this.track, 'scroll', () => {
        this.normalizeLoop();
        if (performance.now() - (this.controlsAt || 0) > 150) this.updateControls();
      }, { passive:true });
      on(this.track, 'wheel', () => this.hold(), { passive:true });
      on(this.track, 'pointerdown', () => { this.pointerHeld = true; this.tween = null; this.updateMotion(); }, { passive:true });
      const release = () => { if (this.pointerHeld) { this.pointerHeld = false; this.hold(); } };
      on(window, 'pointerup', release, { passive:true });
      on(window, 'pointercancel', release, { passive:true });
      on(this, 'mouseenter', () => { this.hovered = true; this.updateMotion(); });
      on(this, 'mouseleave', () => { this.hovered = false; this.updateMotion(); });
      on(this, 'focusin', event => {
        const copy = event.target.closest('[data-clone]');
        if (copy) {
          const link = this.activeItems()[Number(copy.dataset.cloneIndex)]?.querySelector('a.kfm__card');
          if (link) link.focus({ preventScroll:true });
          return;
        }
        this.updateMotion();
        const item = event.target.closest('[data-food]');
        if (item && this.isCarousel()) this.revealItem(item);
      });
      on(this, 'focusout', () => queueMicrotask(() => { if (this.controller) this.updateMotion(); }));
      on(this.track, 'mousedown', event => { if (event.target.closest('[data-clone] a')) event.preventDefault(); });
      on(window, 'resize', () => this.queueLayout(), { passive:true });
      on(this.mobile, 'change', () => this.queueLayout());
      on(this.reduced, 'change', () => { this.tween = null; this.updateMotion(); });
      on(document, 'visibilitychange', () => this.updateMotion());
      on(this.track, 'keydown', event => {
        if (!this.isCarousel() || event.target !== this.track) return;
        let step;
        if (event.key === 'ArrowRight') step = this.rtl ? -1 : 1;
        if (event.key === 'ArrowLeft') step = this.rtl ? 1 : -1;
        if (step !== undefined) { event.preventDefault(); this.move(step); }
        if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.go(event.key === 'Home' ? 0 : this.loop ? (this.activeItems().length - 1) * this.step : this.maxScroll());
        }
      });
      on(document, 'shopify:block:select', event => {
        const item = this.items.find(x => x.dataset.blockId === event.detail?.blockId);
        if (item && this.isCarousel()) this.revealItem(item);
      });
      if ('ResizeObserver' in window) { this.resize = new ResizeObserver(() => this.queueLayout()); this.resize.observe(this.track); }
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { this.inView = entries.some(x => x.isIntersecting); this.updateMotion(); }, { threshold:0 });
        this.observer.observe(this.track);
      } else this.inView = true;
      this.refreshLayout();
    }
    activeItems() { const key = this.mobile.matches ? 'm' : 'd'; return this.items.filter(item => item.dataset[key] !== 'false'); }
    isCarousel() { return this.dataset[this.mobile.matches ? 'layoutM' : 'layoutD'] === 'carousel'; }
    deviceEnabled() { return this.dataset[this.mobile.matches ? 'enabledM' : 'enabledD'] !== 'false'; }
    motionAvailable() { return this.deviceEnabled() && this.dataset.motion !== 'none' && this.dataset.editor !== 'true' && !this.reduced.matches && this.activeItems().some(x => x.dataset.motion === 'true'); }
    autoplayConfigured() { return !this.mobile.matches && this.deviceEnabled() && this.isCarousel() && this.dataset.autoplay === 'true' && this.dataset.editor !== 'true'; }
    autoplayAvailable() { return this.autoplayConfigured() && !this.reduced.matches && this.overflow && this.activeItems().length > 1; }
    removeClones() { this.track?.querySelectorAll('[data-clone]').forEach(copy => copy.remove()); this.loop = null; this.dataset.looping = 'false'; }
    makeClone(item, index) {
      const copy = item.cloneNode(true);
      copy.dataset.clone = 'true';
      copy.dataset.cloneIndex = String(index);
      copy.setAttribute('aria-hidden', 'true');
      for (const element of [copy, ...copy.querySelectorAll('*')]) {
        for (const attr of [...element.attributes]) {
          if (attr.name === 'id' || attr.name === 'data-food' || attr.name === 'data-block-id' || attr.name.startsWith('data-shopify-')) element.removeAttribute(attr.name);
        }
      }
      copy.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(element => element.setAttribute('tabindex', '-1'));
      return copy;
    }
    refreshLayout() {
      if (!this.controller) return;
      const progress = this.position() || 0;
      const oldDevice = this.layoutDevice;
      this.stopFrame();
      this.tween = null;
      this.dataset.rebuilding = 'true';
      this.removeClones();
      const active = this.activeItems();
      this.rtl = getComputedStyle(this.track).direction === 'rtl';
      this.dataset.direction = this.rtl ? 'rtl' : 'ltr';
      this.layoutDevice = this.mobile.matches ? 'm' : 'd';
      const width = active[0]?.getBoundingClientRect().width || 0;
      this.step = width + (parseFloat(getComputedStyle(this.track).gap) || 0);
      if (!this.mobile.matches && this.deviceEnabled() && this.isCarousel() && this.dataset.loop === 'true' && this.dataset.editor !== 'true' && active.length > 1 && width > 0 && this.track.clientWidth > 0) {
        const cycle = this.step * active.length;
        const sets = Math.max(1, Math.ceil((this.track.clientWidth + this.step) / cycle));
        const before = document.createDocumentFragment(), after = document.createDocumentFragment();
        for (let i = 0; i < sets; i++) active.forEach((item, index) => { before.append(this.makeClone(item, index)); after.append(this.makeClone(item, index)); });
        this.track.prepend(before);
        this.track.append(after);
        this.loop = { start:sets * cycle, cycle };
        this.dataset.looping = 'true';
      }
      this.overflow = this.deviceEnabled() && this.isCarousel() && active.length > 1 && (Boolean(this.loop) || this.maxScroll() > 2);
      this.setPosition(oldDevice && oldDevice !== this.layoutDevice ? 0 : progress);
      void this.track.offsetWidth;
      this.dataset.rebuilding = 'false';
      this.updateControls();
      this.updateMotion();
    }
    queueLayout() { cancelAnimationFrame(this.layoutFrame); this.layoutFrame = requestAnimationFrame(() => this.refreshLayout()); }
    maxScroll() { return Math.max(0, this.track.scrollWidth - this.track.clientWidth); }
    currentScroll() { return Math.min(this.maxScroll(), Math.max(0, this.track.scrollLeft * (this.rtl ? -1 : 1))); }
    modulo(value, span) { return ((value % span) + span) % span; }
    position() { return this.loop ? this.modulo(this.currentScroll() - this.loop.start, this.loop.cycle) : this.currentScroll(); }
    setPosition(value) {
      this.autoPosition = this.loop ? this.modulo(value, this.loop.cycle) : Math.min(this.maxScroll(), Math.max(0, value));
      const offset = this.loop ? this.loop.start + this.autoPosition : this.autoPosition;
      this.track.scrollLeft = offset * (this.rtl ? -1 : 1);
    }
    normalizeLoop() {
      if (!this.loop) return;
      const offset = this.currentScroll();
      if (offset < this.loop.start - .1 || offset >= this.loop.start + this.loop.cycle) this.setPosition(offset - this.loop.start);
    }
    move(direction) { this.go(this.position() + direction * (this.step || this.track.clientWidth)); }
    go(value) {
      if (!this.loop && value < this.maxScroll()) this.paused = false;
      this.hold();
      if (this.reduced.matches) { this.setPosition(value); this.updateControls(); return; }
      this.tween = { from:this.position(), to:this.loop ? value : Math.min(this.maxScroll(), Math.max(0, value)), started:null };
      this.startFrame();
    }
    revealItem(item) {
      const r = item.getBoundingClientRect(), t = this.track.getBoundingClientRect();
      if (r.left >= t.left && r.right <= t.right) return;
      if (this.loop) this.go(this.activeItems().indexOf(item) * this.step);
      else this.go(this.currentScroll() + (this.rtl ? t.right - r.right : r.left - t.left));
    }
    hold() {
      this.holding = true;
      clearTimeout(this.holdTimer);
      this.holdTimer = setTimeout(() => { this.holding = false; if (this.controller) this.updateMotion(); }, 1200);
      this.updateMotion();
    }
    updateMotion() {
      if (!this.controller) return;
      const motion = this.motionAvailable(), autoplay = this.autoplayAvailable();
      const visible = this.inView && !document.hidden && !this.paused;
      const focused = this.contains(document.activeElement);
      const wasRunning = this.autoRunning;
      this.autoRunning = autoplay && visible && !focused && !this.pointerHeld && !this.holding && !(this.hovered && this.dataset.pauseHover === 'true');
      if (this.autoRunning && !wasRunning) this.autoPosition = this.position();
      this.dataset.playing = String(motion && visible);
      this.dataset.autoRunning = String(this.autoRunning);
      this.dataset.paused = String(this.paused);
      this.dataset.autoMode = String(autoplay);
      if (this.controls) this.controls.hidden = !(this.overflow && this.nav);
      if (!this.inView || document.hidden) this.tween = null;
      if (this.autoRunning || this.tween) this.startFrame(); else this.stopFrame();
    }
    updateControls() {
      this.controlsAt = performance.now();
      if (this.nav) this.nav.hidden = !this.overflow;
      this.track.tabIndex = this.overflow ? 0 : -1;
      const offset = this.position();
      if (this.previous) this.previous.disabled = !this.loop && offset <= 2;
      if (this.next) this.next.disabled = !this.loop && offset >= this.maxScroll() - 2;
    }
    startFrame() { if (!this.frame && this.controller) this.frame = requestAnimationFrame(time => this.tick(time)); }
    stopFrame() { cancelAnimationFrame(this.frame); this.frame = null; this.lastFrame = null; }
    tick(time) {
      this.frame = null;
      if (!this.controller) return;
      const delta = this.lastFrame == null ? 0 : Math.min(64, Math.max(0, time - this.lastFrame));
      this.lastFrame = time;
      if (this.tween) {
        if (this.tween.started == null) this.tween.started = time;
        const progress = Math.min(1, (time - this.tween.started) / 380);
        const eased = 1 - Math.pow(1 - progress, 3);
        this.setPosition(this.tween.from + (this.tween.to - this.tween.from) * eased);
        if (progress === 1) this.tween = null;
      } else if (this.autoRunning) {
        const offset = this.autoPosition + this.speed * delta / 1000;
        this.setPosition(offset);
        if (!this.loop && offset >= this.maxScroll() - .5) { this.setPosition(this.maxScroll()); this.paused = true; this.updateMotion(); }
      }
      if (time - (this.controlsAt || 0) > 150) this.updateControls();
      if (this.autoRunning || this.tween) this.startFrame(); else this.lastFrame = null;
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      this.observer?.disconnect(); this.resize?.disconnect();
      this.stopFrame(); cancelAnimationFrame(this.layoutFrame); clearTimeout(this.holdTimer);
      this.tween = null; this.autoRunning = false;
      this.removeClones();
      this.dataset.playing = 'false'; this.dataset.autoRunning = 'false'; this.dataset.autoMode = 'false';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ketfii-hot-picks"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(customElements.get('ketfii-hot-picks-v3')) return;

  class HotPicksV3 extends HTMLElement{
    static match(variants,values){
      return variants.find(v=>
        v.options.length===values.length&&
        v.options.every((x,i)=>String(x)===String(values[i]))
      )||null;
    }

    static stops(max,step){
      if(max<=2||step<=0)return [0];
      const out=[0];
      for(let x=step;x<max-2;x+=step)out.push(x);
      out.push(max);
      return out;
    }

    static progress(width,total,offset){
      if(total<=width||total<=0)return {size:100,start:0};
      return {
        size:100*width/total,
        start:100*Math.min(total-width,Math.max(0,Math.abs(offset)))/total
      };
    }

    connectedCallback(){
      this.start=requestAnimationFrame(()=>this.init());
    }

    disconnectedCallback(){
      cancelAnimationFrame(this.start);
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.layoutFrame);
      this.abort?.abort();
      this.resize?.disconnect();
      this.observer?.disconnect();
      clearInterval(this.timer);
      this.abort=null;
    }

    init(){
      if(this.abort||!this.isConnected)return;
      this.track=this.querySelector('[data-track]');
      if(!this.track)return;

      try{
        this.cfg=JSON.parse(this.querySelector('[data-config]').textContent);
      }catch(_){
        return;
      }

      this.abort=new AbortController();
      const signal=this.abort.signal;

      this.cards=Array.from(this.track.querySelectorAll('[data-card]'));
      this.rails=Array.from(this.querySelectorAll('[data-feature-rail]'));
      this.controls=this.querySelector('[data-controls]');
      this.dots=this.querySelector('[data-dots]');
      this.prev=this.querySelector('[data-prev]');
      this.next=this.querySelector('[data-next]');
      this.auto=this.querySelector('[data-auto]');
      this.mobile=matchMedia('(max-width:749px)');
      this.reduced=matchMedia('(prefers-reduced-motion:reduce)');
      this.paused=false;
      this.hover=false;
      this.focused=false;
      this.visible=true;
      this.editor=Boolean(window.Shopify?.designMode);

      this.colorNames=(this.cfg.colorNames||'')
        .toLowerCase().split(',').map(x=>x.trim());

      this.colors=new Map((this.cfg.colorMap||'').split(/\r?\n/).map(line=>{
        const i=line.indexOf('=');
        return i<0?['','']:[
          line.slice(0,i).trim().toLowerCase(),
          line.slice(i+1).trim()
        ];
      }));

      this.cards.forEach(card=>this.prepare(card));
      this.addEventListener('pointerover', event => {
        if (event.pointerType !== 'mouse' || !matchMedia('(hover:hover) and (pointer:fine)').matches) return;
        const card = event.target.closest('[data-card]');
        if (!card || card.hasAttribute('data-variant-changed')) return;
        const template = card.querySelector('template[data-kfhp-hover]');
        if (!template) return;
        const content = template.content.cloneNode(true);
        const image = content.querySelector('img');
        image.loading = 'eager';
        image.fetchPriority = 'low';
        image.style.opacity = '0';
        const ready = () => image.style.removeProperty('opacity');
        image.addEventListener('load', ready, { once: true, signal });
        template.replaceWith(content);
        if (image.complete && image.naturalWidth) ready();
      }, {signal});

      this.rails.forEach(rail=>{
        rail.addEventListener('scroll',()=>this.refreshRail(rail),{
          signal,passive:true
        });

        rail.addEventListener('keydown',e=>{
          if(
            e.target!==rail||
            !this.mobile.matches||
            this.dataset.featuresM!=='carousel'||
            !['ArrowLeft','ArrowRight'].includes(e.key)
          )return;

          e.preventDefault();
          e.stopPropagation();

          const step=rail.firstElementChild.getBoundingClientRect().width+
            (parseFloat(getComputedStyle(rail).columnGap)||0);

          rail.scrollBy({
            left:(e.key==='ArrowRight'?1:-1)*step,
            behavior:this.reduced.matches?'auto':'smooth'
          });
        },{signal});
      });

      this.addEventListener('click',e=>this.onClick(e),{signal});

      this.addEventListener('change',e=>{
        if(!e.target.matches('[data-variant-select]'))return;
        const card=e.target.closest('[data-card]');
        const state=card._kfhp;
        const v=state?.variants.find(v=>String(v.id)===e.target.value);

        if(v){
          state.values=[...v.options];
          this.update(card);
        }
        this.paused=true;
        this.refresh();
      },{signal});

      this.track.addEventListener('scroll',()=>{
        cancelAnimationFrame(this.frame);
        this.frame=requestAnimationFrame(()=>this.refresh());
      },{signal,passive:true});

      this.track.addEventListener('pointerdown',()=>{
        this.paused=true;
        this.refresh();
      },{signal,passive:true});

      this.track.addEventListener('keydown',e=>{
        if(
          e.target!==this.track||
          !this.carousel()||
          !['ArrowLeft','ArrowRight'].includes(e.key)
        )return;

        e.preventDefault();
        this.paused=true;

        const rtl=getComputedStyle(this.track).direction==='rtl';
        this.step((e.key==='ArrowRight'?1:-1)*(rtl?-1:1));
      },{signal});

      this.addEventListener('pointerenter',e=>{
        if(e.pointerType==='mouse')this.hover=true;
      },{signal});

      this.addEventListener('pointerleave',()=>{
        this.hover=false;
      },{signal});

      this.addEventListener('focusin',()=>{
        this.focused=true;
      },{signal});

      this.addEventListener('focusout',e=>{
        this.focused=this.contains(e.relatedTarget);
      },{signal});

      this.mobile.addEventListener('change',()=>this.scheduleLayout(),{signal});
      this.reduced.addEventListener('change',()=>this.refresh(),{signal});
      window.addEventListener('resize',()=>this.scheduleLayout(),{signal,passive:true});
      this.addEventListener('load',()=>this.scheduleLayout(),{signal,capture:true});

      if(document.fonts){
        document.fonts.ready.then(()=>{
          if(!signal.aborted)this.scheduleLayout();
        });
        document.fonts.addEventListener('loadingdone',()=>this.scheduleLayout(),{signal});
      }

      if('ResizeObserver'in window){
        let width=0;
        this.resize=new ResizeObserver(entries=>{
          const changed=entries.some(e=>{
            if(e.target!==this.track)return true;
            const next=e.contentRect.width;
            if(Math.abs(next-width)<.5)return false;
            width=next;
            return true;
          });
          if(changed)this.scheduleLayout();
        });
        this.resize.observe(this.track);
        this.querySelectorAll(
          '.kfhp-title,.kfhp-description,.kfhp-options,.kfhp-price-area,.kfhp-feature-copy,.kfhp-badges'
        ).forEach(el=>this.resize.observe(el));
      }

      if('IntersectionObserver'in window){
        this.observer=new IntersectionObserver(entries=>{
          this.visible=entries[0].isIntersecting;
        });
        this.observer.observe(this);
      }

      document.addEventListener('shopify:block:select',e=>{
        const card=this.cards.find(c=>c.dataset.blockId===e.detail?.blockId);
        if(!card)return;
        this.paused=true;
        this.refresh();
        this.go(Math.min(this.cards.indexOf(card),this.points.length-1));
      },{signal});

      this.scheduleLayout();
      this.refresh();

      if(this.dataset.autoplay==='true'&&!this.editor){
        this.timer=setInterval(()=>{
          if(
            !document.hidden&&this.visible&&!this.paused&&
            !this.hover&&!this.focused&&!this.reduced.matches&&this.carousel()
          )this.step(1,true);
        },Math.max(3,Number(this.dataset.interval)||6)*1000);
      }
    }

    prepare(card){
      const node=card.querySelector('[data-variant-data]');
      if(!node)return;

      let data;
      try{
        data=JSON.parse(node.textContent);
      }catch(_){
        return;
      }

      const v=data.variants.find(v=>String(v.id)===String(data.selected))||
        data.variants[0];
      if(!v)return;

      card._kfhp={variants:data.variants,values:[...v.options]};
      card.querySelectorAll('[data-product-link]').forEach(a=>{
        a.dataset.baseUrl=a.href;
      });

      card.querySelectorAll('[data-option-index]').forEach(group=>{
        const colorGroup=this.colorNames.includes(group.dataset.optionName.toLowerCase());

        group.querySelectorAll('[data-value]').forEach(button=>{
          const swatch=button.querySelector('.kfhp-swatch');
          const color=this.colors.get(button.dataset.value.toLowerCase())||
            button.dataset.value;

          if(
            colorGroup&&
            !swatch.hasAttribute('data-native-swatch')&&
            CSS.supports('color',color)
          ){
            swatch.style.backgroundColor=color;
            swatch.hidden=false;
          }

          if(!swatch.hidden&&this.dataset.colorLabels==='false'){
            button.querySelector('[data-choice-text]').classList.add('kfhp-sr');
          }
        });
      });

      this.sync(card);
      card.querySelector('[data-native]').hidden=true;
      card.querySelector('[data-options]').hidden=false;
    }

    sync(card){
      card.querySelectorAll('[data-option-index]').forEach(group=>{
        const value=card._kfhp.values[Number(group.dataset.optionIndex)];
        group.querySelector('[data-selected-label]').textContent=value;
        group.querySelectorAll('[data-value]').forEach(b=>{
          b.setAttribute('aria-pressed',String(b.dataset.value===String(value)));
        });
      });
    }

    update(card){
      const state=card._kfhp;
      const v=HotPicksV3.match(state.variants,state.values);

      this.sync(card);
      card.toggleAttribute('data-unavailable',!v);

      const decode=text=>{
        const el=document.createElement('textarea');
        el.innerHTML=text;
        return el.value;
      };

      card.querySelector('[data-price]').textContent=
        v?decode(v.priceText):this.cfg.unavailable;

      const compare=card.querySelector('[data-compare]');
      compare.hidden=!v||!(v.compare>v.price);
      compare.textContent=v?decode(v.compareText):'';

      const stock=card.querySelector('[data-stock]');
      stock.hidden=!v||v.available;
      stock.textContent=this.cfg.soldOut;

      card.querySelector('[data-variant-select]').value=v?String(v.id):'';

      const badge=card.querySelector('[data-discount]');
      if(badge){
        const n=v&&v.compare>v.price?
          Math.round((v.compare-v.price)/v.compare*100):0;
        badge.hidden=!v||!(v.compare>v.price);
        const value=this.cfg.discountFormat==='amount'?
          decode(v?.savingText||''):n+'%';
        badge.textContent=[this.cfg.saveLabel,value].filter(Boolean).join(' ');
      }

      const ids=Array.from(
        card.querySelectorAll('[data-value][aria-pressed="true"]')
      ).map(b=>b.dataset.valueId).filter(Boolean);

      card.querySelectorAll('[data-product-link]').forEach(a=>{
        const url=new URL(a.dataset.baseUrl||a.href,location.origin);
        url.searchParams.delete('variant');
        url.searchParams.delete('option_values');

        if(v){
          url.searchParams.set('variant',v.id);
        }else if(ids.length===state.values.length){
          url.searchParams.set('option_values',ids.join(','));
        }
        a.href=url.toString();
      });

      if(v&&this.dataset.swapImage==='true'&&v.image){
        const image=card.querySelector('.kfhp-main-image');
        if(image){
          const candidate = width => {
            const url = new URL(v.image, location.origin);
            url.searchParams.set('width', String(width));
            return url.href;
          };
          const srcset = [240,400,600,800,1000,1200].map(width => `${candidate(width)} ${width}w`).join(', ');
          card.querySelectorAll('[data-mobile-source]').forEach(source => { source.srcset = srcset; });
          image.srcset = srcset;
          image.src = candidate(800);
        }
      }

      card.setAttribute('data-variant-changed','');
      this.scheduleLayout();
    }

    onClick(e){
      const b=e.target.closest('button');
      if(!b||!this.contains(b))return;

      if(b.hasAttribute('data-value')){
        const card=b.closest('[data-card]');
        if(!card?._kfhp)return;

        card._kfhp.values[
          Number(b.closest('[data-option-index]').dataset.optionIndex)
        ]=b.dataset.value;

        this.update(card);
        this.paused=true;
        this.refresh();
      }else if(b.hasAttribute('data-prev')){
        this.paused=true;
        this.step(-1);
      }else if(b.hasAttribute('data-next')){
        this.paused=true;
        this.step(1);
      }else if(b.hasAttribute('data-page')){
        this.paused=true;
        this.go(Number(b.dataset.page));
      }else if(b.hasAttribute('data-auto')){
        this.paused=!this.paused;
        if(!this.paused){
          this.focused=false;
          this.hover=false;
        }
        this.refresh();
      }
    }

    scheduleLayout(){
      cancelAnimationFrame(this.layoutFrame);
      this.layoutFrame=requestAnimationFrame(()=>{
        if(!this.isConnected||!this.abort||!this.track.clientWidth)return;

        const featureCarousel=this.mobile.matches&&this.dataset.featuresM==='carousel';
        const columns=Number(
          this.mobile.matches?this.dataset.featureColsM:this.dataset.featureCols
        )||2;
        const count=Math.max(0,...this.rails.map(rail=>rail.children.length));
        const rows=featureCarousel?1:Math.max(1,Math.ceil(count/columns));

        if(this.dataset.alignCards==='false'){
          this.style.removeProperty('--kfhp-feature-rows');
        }else{
          this.style.setProperty('--kfhp-feature-rows',String(rows));
        }

        const parts=Array.from(this.querySelectorAll('[data-equal]'));
        parts.forEach(el=>{
          el.style.minHeight='';
          el.style.height='';
          el.removeAttribute('data-equal-active');
        });

        this.rails.forEach(rail=>this.refreshRail(rail));

        const badgeHeights = this.cards.map(card => Math.ceil(card.querySelector('.kfhp-badges').getBoundingClientRect().height));
        this.cards.forEach((card, index) => {
          const value = badgeHeights[index] + 'px';
          if (card.style.getPropertyValue('--kfhp-badges-height') !== value) card.style.setProperty('--kfhp-badges-height', value);
        });

        if(this.dataset.alignCards!=='false'){
          const heights={};

          parts.forEach(el=>{
            const key=el.dataset.equal;
            heights[key]=Math.max(
              heights[key]||0,
              Math.ceil(el.getBoundingClientRect().height)
            );
          });

          parts.forEach(el=>{
            const h=heights[el.dataset.equal];
            if(h>0){
              el.setAttribute('data-equal-active','');
              el.style.minHeight=h+'px';
              if(el.dataset.equal==='features')el.style.height=h+'px';
            }
          });
        }

        this.refresh();
      });
    }

    carousel(){
      return(
        this.mobile.matches?this.dataset.layoutM:this.dataset.layoutD
      )==='carousel';
    }

    refreshRail(rail){
      const bar=rail.nextElementSibling;
      const active=this.mobile.matches&&this.dataset.featuresM==='carousel'&&
        rail.scrollWidth-rail.clientWidth>2;

      rail.tabIndex=active?0:-1;
      bar.hidden=!active;

      if(active){
        const p=HotPicksV3.progress(
          rail.clientWidth,rail.scrollWidth,rail.scrollLeft
        );
        bar.firstElementChild.style.width=p.size+'%';
        bar.firstElementChild.style.marginInlineStart=p.start+'%';
      }
    }

    refresh(){
      if(!this.isConnected||!this.cards.length)return;
      this.rails.forEach(rail=>this.refreshRail(rail));

      const max=Math.max(0,this.track.scrollWidth-this.track.clientWidth);
      const step=this.cards[0].getBoundingClientRect().width+
        (parseFloat(getComputedStyle(this.track).columnGap)||0);

      this.points=HotPicksV3.stops(max,step);
      const offset=Math.min(max,Math.abs(this.track.scrollLeft));

      this.index=this.points.reduce((best,x,i)=>
        Math.abs(x-offset)<Math.abs(this.points[best]-offset)?i:best,0
      );

      this.track.tabIndex=this.carousel()&&max>2?0:-1;
      this.controls.hidden=!this.carousel()||max<=2||!this.controls.children.length;
      this.style.setProperty('--kfhp-nav-y',(this.track.offsetTop+this.track.offsetHeight/2)+'px');

      if(this.dots){
        if(this.dots.children.length!==this.points.length){
          const frag=document.createDocumentFragment();

          this.points.forEach((_,i)=>{
            const b=document.createElement('button');
            b.type='button';
            b.className='kfhp-dot';
            b.dataset.page=String(i);
            b.setAttribute('aria-label',this.cfg.page+' '+(i+1));
            b.setAttribute('aria-controls',this.track.id);
            frag.append(b);
          });

          this.dots.replaceChildren(frag);
        }

        Array.from(this.dots.children).forEach((b,i)=>{
          b.setAttribute('aria-current',String(i===this.index));
        });
      }

      const loop=this.dataset.loop==='true';
      if(this.prev)this.prev.disabled=!loop&&this.index===0;
      if(this.next)this.next.disabled=!loop&&this.index===this.points.length-1;

      if(this.auto){
        const playing=!this.paused&&!this.reduced.matches&&!this.editor;
        this.auto.textContent=playing?this.cfg.pause:this.cfg.play;
        this.auto.disabled=this.reduced.matches||this.editor;
        this.auto.setAttribute('aria-pressed',String(playing));
      }
    }

    step(delta,automatic=false){
      this.refresh();
      if(!this.carousel()||this.points.length<2)return;

      let i=this.index+delta;
      if(automatic||this.dataset.loop==='true'){
        i=(i+this.points.length)%this.points.length;
      }
      this.go(Math.max(0,Math.min(this.points.length-1,i)));
    }

    go(i){
      if(!this.carousel()||!this.points?.length)return;
      const rtl=getComputedStyle(this.track).direction==='rtl';

      this.track.scrollTo({
        left:(rtl?-1:1)*this.points[i],
        behavior:this.reduced.matches?'auto':'smooth'
      });

      this.refresh();
    }
  }

  customElements.define('ketfii-hot-picks-v3',HotPicksV3);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ketfii-product-series"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ketfii-product-series-v2'))customElements.define('ketfii-product-series-v2',class extends HTMLElement{
 connectedCallback(){if(this.bound)return;this.bound=true;this.classList.add('kps--ready');this.addEventListener('change',e=>{const card=e.target.closest('[data-card]');if(e.target.matches('[data-variant-select],[data-media-select]'))this.update(card,e.target.value);if(e.target.matches('[data-other-option]'))this.choose(card,Number(e.target.dataset.otherOption),e.target.value)});this.addEventListener('click',e=>{const toggle=e.target.closest('[data-spec-toggle]');if(toggle){const open=toggle.getAttribute('aria-expanded')!=='true';toggle.setAttribute('aria-expanded',String(open));toggle.closest('.kps__specs').classList.toggle('is-open',open)}const color=e.target.closest('[data-color]');if(color)this.choose(color.closest('[data-card]'),Number(color.dataset.optionIndex),color.dataset.color)});this.querySelectorAll('[data-swatches]').forEach(e=>e.hidden=false)}
 choose(card,index,value){const variants=JSON.parse(card.querySelector('[data-variants]').textContent);const current=variants.find(v=>String(v.id)===card.querySelector('[data-media-select]')?.value)||variants[0];const wanted=[...current.options];wanted[index]=value;const next=variants.find(v=>v.options.every((x,i)=>x===wanted[i]))||variants.find(v=>v.available&&v.options[index]===value)||variants.find(v=>v.options[index]===value);if(next)this.update(card,next.id)}
 update(card,id){const data=card.querySelector('[data-variants]');if(!data)return;let variants;try{variants=JSON.parse(data.textContent)}catch{return}const v=variants.find(x=>String(x.id)===String(id));if(!v)return;card.querySelectorAll('[data-media-select],[data-variant-select]').forEach(s=>s.value=String(v.id));card.querySelectorAll('[data-other-option]').forEach(s=>s.value=v.options[Number(s.dataset.otherOption)]);card.querySelectorAll('[data-color]').forEach(b=>b.setAttribute('aria-pressed',String(v.options[Number(b.dataset.optionIndex)]===b.dataset.color)));card.querySelectorAll('[data-variant]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.variant===String(v.id))));card.querySelector('[data-price]').textContent=v.price;const compare=card.querySelector('[data-compare]');compare.hidden=!v.onSale;compare.textContent=v.compare;const badge=card.querySelector('[data-discount]');if(badge){badge.hidden=!v.onSale;badge.querySelector('[data-saving]').textContent=card.dataset.badge==='percent'?v.percent+'%':v.saving}const image=card.querySelector('img.kps__image');if(image&&v.image){image.removeAttribute('srcset');image.removeAttribute('sizes');image.src=v.image;image.alt=v.title}const buy=card.querySelector('[data-buy]');if(buy){buy.disabled=!v.available;buy.textContent=v.available?buy.dataset.ready:buy.dataset.soldout}card.querySelectorAll('[data-buy-link],[data-product-link]').forEach(a=>a.href=v.url)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ketfii-scroll-story"] && !Shopify.designMode) return;
  try {
    
/* Native scroll; local tag physics only. No global cursor tracking or external dependencies. */
(() => {
  if (customElements.get('ketfii-scroll-story')) return;
  const clamp = (v, a=0, b=1) => Math.min(b, Math.max(a,v));
  const mix = (a,b,t) => a+(b-a)*t;
  const ease = t => { t=clamp(t); return t*t*(3-2*t); };
  const rand = seed => () => { seed |= 0; seed = seed + 0x6D2B79F5 | 0; let t = Math.imul(seed ^ seed >>> 15, 1 | seed); t ^= t + Math.imul(t ^ t >>> 7, 61 | t); return ((t ^ t >>> 14) >>> 0) / 4294967296; };
// Lightweight bounded tag simulation; pointer input is limited to the tag floor.
class TagFloor {
  constructor(host,on){
    this.host=host;this.el=host.querySelector('.ks-tags');this.items=this.el?[...this.el.querySelectorAll('.ks-tag')]:[];
    this.bodies=[];this.raf=0;this.visible=false;
    if(!this.el)return;
    on(this.el,'pointermove',e=>this.pointerMove(e));
    on(this.el,'pointerdown',e=>this.pointerDown(e));
    on(this.el,'pointerup',e=>this.release(e));
    on(this.el,'pointercancel',e=>this.release(e,true));
    on(this.el,'lostpointercapture',e=>this.release(e,true));
    on(this.el,'pointerleave',()=>{if(!this.drag)this.pointer=null;});
    on(this.el,'keydown',e=>{if((e.key==='Enter'||e.key===' ')&&e.target.classList.contains('ks-tag')&&this.enabled){e.preventDefault();const b=this.bodies.find(b=>b.el===e.target);if(b)this.kick(b,160,-260);}});
    on(document,'visibilitychange',()=>{if(document.hidden)this.stop();else if(this.visible)this.wake();});
    this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;if(!this.inView)this.stop();else if(this.visible)this.wake();});
    this.observer.observe(this.el);
  }
  configure(){
    if(!this.el)return;
    this.enabled=this.host.dataset.physics!=='false'&&!this.host.reduced.matches&&!this.host.gridHidesFinal&&this.items.length>0;
    this.el.classList.toggle('ks-physical',this.enabled);
    this.items.forEach(el=>{el.disabled=!this.enabled;el.style.transform='';});
    if(!this.enabled){this.stop();return;}
    const W=this.el.clientWidth,H=this.el.clientHeight;
    if(W<20||H<20)return;
    if(this.W===W&&this.H===H&&this.bodies.length===this.items.length){this.render();return;}
    this.stop();this.W=W;this.H=H;const random=rand(this.host.num('seed',18)+71);
    this.bodies=this.items.map((el,i)=>{
      const w=el.offsetWidth,h=el.offsetHeight;
      return {el,w,h,x:clamp((i+.5)/this.items.length*W+(random()-.5)*35,w/2+5,W-w/2-5),y:H-h/2-12-random()*Math.min(H*.5,90),vx:(random()-.5)*35,vy:0,a:(random()-.5)*.65,av:0};
    });
    for(let i=0;i<150;i++)this.step(1/120);
    this.render();if(this.visible)this.wake();
  }
  ext(b){const c=Math.abs(Math.cos(b.a)),s=Math.abs(Math.sin(b.a));return{x:(b.w*c+b.h*s)/2,y:(b.h*c+b.w*s)/2};}
  bounds(b){
    let r=this.ext(b);for(let i=0;i<20&&(r.y>(this.H-10)/2||r.x>(this.W-10)/2);i++){b.a*=.85;r=this.ext(b);}
    const e=this.host.num('bounce',28)/100;
    if(b.x<r.x+4){b.x=r.x+4;b.vx=Math.abs(b.vx)*e;}
    if(b.x>this.W-r.x-4){b.x=this.W-r.x-4;b.vx=-Math.abs(b.vx)*e;}
    if(b.y<r.y+4){b.y=r.y+4;b.vy=Math.abs(b.vy)*e;}
    if(b.y>this.H-r.y-5){b.y=this.H-r.y-5;b.vy=Math.abs(b.vy)<45?0:-Math.abs(b.vy)*e;b.vx*=.91;b.av*=.8;}
  }
  collide(a,b){
    const dx=b.x-a.x,dy=b.y-a.y;
    if(Math.abs(dx)>(a.w+a.h+b.w+b.h)/2||Math.abs(dy)>(a.w+a.h+b.w+b.h)/2)return;
    const ac=Math.cos(a.a),as=Math.sin(a.a),bc=Math.cos(b.a),bs=Math.sin(b.a);
    let depth=Infinity,nx=0,ny=0;
    for(const [x,y] of [[ac,as],[-as,ac],[bc,bs],[-bs,bc]]){
      const ra=Math.abs(x*ac+y*as)*a.w/2+Math.abs(-x*as+y*ac)*a.h/2;
      const rb=Math.abs(x*bc+y*bs)*b.w/2+Math.abs(-x*bs+y*bc)*b.h/2;
      const dist=dx*x+dy*y,overlap=ra+rb-Math.abs(dist);
      if(overlap<=0)return;
      if(overlap<depth){depth=overlap;const sign=dist<0?-1:1;nx=x*sign;ny=y*sign;}
    }
    const wa=this.drag?.b===a?0:1,wb=this.drag?.b===b?0:1,total=wa+wb;if(!total)return;
    const push=Math.max(0,depth-.1)*.8/total;
    a.x-=nx*push*wa;a.y-=ny*push*wa;b.x+=nx*push*wb;b.y+=ny*push*wb;
    const speed=(b.vx-a.vx)*nx+(b.vy-a.vy)*ny;
    if(speed<0){const impulse=-(1+this.host.num('bounce',28)/100)*speed/total;a.vx-=impulse*nx*wa;a.vy-=impulse*ny*wa;b.vx+=impulse*nx*wb;b.vy+=impulse*ny*wb;
      const spin=clamp((b.vx-a.vx)*ny*.0005,-.15,.15);a.av-=spin*wa;b.av+=spin*wb;}
  }
  step(dt){
    const gravity=this.host.num('gravity',700);
    for(const b of this.bodies){
      if(this.drag?.b===b){b.vx=clamp((this.drag.x-b.x)*22,-650,650);b.vy=clamp((this.drag.y-b.y)*22,-650,650);}
      else b.vy+=gravity*dt;
      b.vx=clamp(b.vx,-800,800)*.992;b.vy=clamp(b.vy,-800,800)*.996;b.av=clamp(b.av,-2,2)*.97;
      b.x+=b.vx*dt;b.y+=b.vy*dt;b.a=clamp(b.a+b.av*dt,-.6,.6);this.bounds(b);
    }
    for(let pass=0;pass<5;pass++){
      for(let i=0;i<this.bodies.length;i++)for(let j=i+1;j<this.bodies.length;j++)this.collide(this.bodies[i],this.bodies[j]);
      this.bodies.forEach(b=>this.bounds(b));
    }
  }
  render(){this.bodies.forEach(b=>b.el.style.transform=`translate3d(${b.x-b.w/2}px,${b.y-b.h/2}px,0) rotate(${b.a}rad)`);}
  kick(b,vx,vy){b.vx=clamp(b.vx+vx,-700,700);b.vy=clamp(b.vy+vy,-650,400);b.av+=vx*.002;this.wake();}
  point(e){const r=this.el.getBoundingClientRect();return{x:e.clientX-r.left,y:e.clientY-r.top,t:e.timeStamp};}
  pointerDown(e){
    if(!this.enabled||!this.visible||this.drag||e.button!==0)return;
    const tag=e.target.closest('.ks-tag'),b=this.bodies.find(b=>b.el===tag);if(!b)return;
    const p=this.point(e);this.pointer=p;this.drag={b,id:e.pointerId,x:b.x,y:b.y,ox:b.x-p.x,oy:b.y-p.y};
    this.el.setPointerCapture(e.pointerId);tag.classList.add('ks-grabbed');this.wake();
  }
  pointerMove(e){
    if(!this.enabled||!this.visible)return;
    const p=this.point(e),old=this.pointer;this.pointer=p;
    if(this.drag){if(this.drag.id===e.pointerId){this.drag.x=p.x+this.drag.ox;this.drag.y=p.y+this.drag.oy;this.wake();}return;}
    if(e.pointerType!=='mouse'&&e.pointerType!=='pen')return;
    if(!old||p.t-old.t>180)return;
    const dx=p.x-old.x,dy=p.y-old.y,dist=dx*dx+dy*dy;if(dist<.2)return;
    const force=this.host.num('push',100)/100;
    for(const b of this.bodies){
      const t=clamp(((b.x-old.x)*dx+(b.y-old.y)*dy)/dist),x=old.x+t*dx,y=old.y+t*dy;
      const c=Math.cos(b.a),s=Math.sin(b.a),lx=(x-b.x)*c+(y-b.y)*s,ly=-(x-b.x)*s+(y-b.y)*c;
      if(Math.abs(lx)<b.w/2+12&&Math.abs(ly)<b.h/2+12){const speed=clamp(Math.sqrt(dist)*15,60,350)*force;this.kick(b,Math.sign(dx||b.x-x)*speed,-Math.max(85,speed*.75));}
    }
  }
  release(e,cancel=false){
    if(!this.drag||this.drag.id!==e.pointerId)return;
    const {b,id}=this.drag;this.drag=null;b.el.classList.remove('ks-grabbed');
    if(cancel){b.vx=0;b.vy=0;}else if(Math.abs(b.vx)+Math.abs(b.vy)<35){b.vy=-140;b.av=.8;}
    if(this.el.hasPointerCapture(id))this.el.releasePointerCapture(id);
    this.pointer=null;this.wake();
  }
  setVisible(v){if(this.visible===v)return;this.visible=v;if(v)this.wake();else this.stop();}
  wake(){if(!this.enabled||!this.visible||this.inView===false||document.hidden)return;this.until=performance.now()+5000;if(!this.raf){this.last=0;this.raf=requestAnimationFrame(t=>this.tick(t));}}
  tick(t){this.raf=0;if(!this.visible||!this.enabled||this.inView===false||document.hidden)return;const dt=this.last?clamp((t-this.last)/1000,0,1/30):1/60;this.last=t;this.step(dt/2);this.step(dt/2);this.render();if(this.drag||t<this.until)this.raf=requestAnimationFrame(x=>this.tick(x));}
  stop(){cancelAnimationFrame(this.raf);this.raf=0;this.last=0;if(this.drag){const {id,b}=this.drag;this.drag=null;b.el.classList.remove('ks-grabbed');if(this.el.hasPointerCapture(id))this.el.releasePointerCapture(id);}this.pointer=null;}
  destroy(){this.stop();this.observer?.disconnect();}
}

  class KetfiiScrollStory extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected=true; this.abort=new AbortController();
      this.stage=this.querySelector('.ks-stage'); this.intro=this.querySelector('.ks-intro');
      this.final=this.querySelector('.ks-final'); this.cards=[...this.querySelectorAll('.ks-card')];
      this.cardBox=this.querySelector('.ks-cards');
      this.slotBox=this.querySelector('.ks-slots'); this.label=this.querySelector('.ks-status');
      this.media=matchMedia('(max-width:749px)'); this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
      const on=(el,type,fn,opts={})=>el.addEventListener(type,fn,{...opts,signal:this.abort.signal});
      this.schedule=()=>{if (!this.raf) this.raf=requestAnimationFrame(()=>{this.raf=0;this.paint();});};
      const scroll=()=>{this.editorP=null;this.focusCard=false;this.schedule();};
      on(window,'scroll',scroll,{passive:true});
      on(document,'scroll',scroll,{passive:true,capture:true});
      on(window,'resize',()=>{clearTimeout(this.resizeTimer);this.resizeTimer=setTimeout(()=>this.setup(),150);},{passive:true});
      on(this.media,'change',()=>this.setup()); on(this.reduced,'change',()=>this.setup());
      on(this,'click',e=>{const b=e.target.closest('[data-ks-step]');if(b)this.go(Number(b.dataset.ksStep));const exit=e.target.closest('[data-ks-exit]');if(exit)this.leave(exit.dataset.ksExit);});
      on(this,'focusin',e=>{if(e.target.closest('.ks-card')&&e.target.matches(':focus-visible')){this.focusCard=true;this.schedule();}});
      on(this,'focusout',()=>{queueMicrotask(()=>{this.focusCard=!!document.activeElement?.closest?.('.ks-card')&&this.contains(document.activeElement)&&document.activeElement.matches(':focus-visible');this.schedule();});});
      on(document,'shopify:block:select',e=>{if(this.contains(e.target)){this.editorP=1;this.schedule();}});
      on(document,'shopify:block:deselect',()=>{this.editorP=null;this.schedule();});
      this.ro=new ResizeObserver(()=>{clearTimeout(this.measureTimer);this.measureTimer=setTimeout(()=>this.measure(),80);});
      this.ro.observe(this.intro);this.ro.observe(this.final);
      this.floor=new TagFloor(this,on);
      // Follow transformed/smooth-scrolling themes too; redraw only when the section moves.
      this.watch=()=>{if(!this.inView||!this.isConnected)return;const top=this.getBoundingClientRect().top;if(Math.abs(top-(this.lastTop??Infinity))>.1){this.lastTop=top;this.editorP=null;this.schedule();}this.watchRaf=requestAnimationFrame(this.watch);};
      this.visibility=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;cancelAnimationFrame(this.watchRaf);if(this.inView)this.watch();});
      this.visibility.observe(this);
      this.setup();
      document.fonts?.ready.then(()=>{if(this.isConnected)this.setup();});
    }
    disconnectedCallback(){this.abort?.abort();this.ro?.disconnect();this.visibility?.disconnect();this.floor?.destroy();cancelAnimationFrame(this.raf);cancelAnimationFrame(this.watchRaf);clearTimeout(this.resizeTimer);clearTimeout(this.measureTimer);this._connected=false;}
    num(key,fallback){const n=Number(this.dataset[key]);return Number.isFinite(n)&&this.dataset[key]!==undefined?n:fallback;}
    syncMobileGrid(){
      const mobileGrid=this.media.matches&&this.dataset.mobileMode==='grid';
      const content=this.dataset.mobileGridContent||'all';
      this.gridHidesFinal=mobileGrid&&(content==='intro'||content==='images');
      // Reuse the same cards inside phase three; restore their stage before desktop animation measures.
      const target=mobileGrid&&content==='final'?this.querySelector('.ks-panel'):this.stage;
      if(this.cardBox.parentElement!==target){
        if(target===this.stage)this.stage.insertBefore(this.cardBox,this.querySelector('.ks-controls'));
        else target.append(this.cardBox);
      }
    }
    setup(){
      const m=this.media.matches;
      this.syncMobileGrid();
      this.scroller=null;
      for(let el=this.parentElement;el&&el!==document.body&&el!==document.documentElement;el=el.parentElement){
        if(/auto|scroll|overlay/.test(getComputedStyle(el).overflowY)&&el.scrollHeight>el.clientHeight+1){this.scroller=el;break;}
      }
      this.active=this.cards.filter(c=>!m||c.dataset.mobileOff!=='true');
      this.cards.forEach(c=>c.dataset.hidden=String(!this.active.includes(c)));
      this.slotBox.replaceChildren(...this.active.map(()=>{const s=document.createElement('div');s.className='ks-slot';return s;}));
      this.slots=[...this.slotBox.children];
      this.style.setProperty('--ks-cols',m?this.num('colsM',2):this.num('colsD',3));
      this.style.setProperty('--ks-length',this.num(m?'lengthM':'lengthD',4));
      this.style.setProperty('--ks-vh',CSS.supports('height','100svh')?'100svh':window.innerHeight+'px');
      this.staticMode=this.reduced.matches||this.dataset.motion==='off'||(m&&this.dataset.mobileMode==='grid')||!this.active.length;
      this.classList.toggle('ks-ready',!this.staticMode);this.classList.toggle('ks-static',this.staticMode);
      this.style.removeProperty('--ks-stage-h');
      this.measure();
    }
    resetStatic(){
      this.classList.remove('ks-ready','ks-short');this.classList.add('ks-static');
      this.stage.style.transform='';
      this.intro.style.cssText='';this.final.style.cssText='';this.final.removeAttribute('inert');this.final.removeAttribute('aria-hidden');
      this.cards.forEach(c=>{c.style.transform='';c.style.width='';c.style.height='';c.style.zIndex='';});
      this.style.setProperty('--ks-floor-h',this.num(this.media.matches?'floorM':'floorD',this.media.matches?110:160)+'px');
      this.floor?.configure();this.floor?.setVisible(!this.gridHidesFinal);
    }
    measure(){
      if(!this._connected)return;
      if(this.staticMode){this.resetStatic();return;}
      const m=this.media.matches;
      const probeH=this.querySelector('.ks-view-probe').getBoundingClientRect().height;
      const H=Math.max(1,Math.min(probeH,this.scroller?this.scroller.clientHeight-this.topOffset():probeH));
      this.style.setProperty('--ks-view-h',H+'px');
      this.classList.toggle('ks-short',H<700);
      const copy=this.querySelector('.ks-copy-main');
      const floorHeight=this.num(m?'floorM':'floorD',m?110:160);
      this.style.setProperty('--ks-floor-h',floorHeight+'px');
      const finalRows=Math.ceil(this.active.length/this.num(m?'colsM':'colsD',3));
      const tagArea=this.querySelector('.ks-tags');
      const safeFloor=tagArea?Math.max(floorHeight,[...tagArea.children].reduce((a,t)=>a+t.offsetWidth*t.offsetHeight,0)/Math.max(100,tagArea.clientWidth)*1.8+24):0;
      this.style.setProperty('--ks-floor-h',safeFloor+'px');
      const copyHeight=copy.getBoundingClientRect().height+(tagArea?safeFloor+20:0);
      const panel=this.querySelector('.ks-panel');
      const panelHead=panel.querySelector('.ks-panel-head').getBoundingClientRect().height;
      const panelSub=panel.querySelector('.ks-panel-sub')?.getBoundingClientRect().height||0;
      const gridHeight=finalRows*(m?72:86)+Math.max(0,finalRows-1)*this.num('gap',12)+panelHead+panelSub+60;
      const needed=(m?copyHeight+16+gridHeight:Math.max(copyHeight,gridHeight))+(m?102:112);
      const stageHeight=Math.ceil(Math.max(H,needed));
      this.style.setProperty('--ks-stage-h',stageHeight+'px');
      this.travel=Math.max(1,H*(this.num(m?'lengthM':'lengthD',4)-1)*(m?this.num('mobileTravel',55)/100:1));
      this.style.setProperty('--ks-travel',this.travel+'px');
      this.style.setProperty('--ks-exit',this.num('exitSpace',60)+'px');
      const box=this.stage.getBoundingClientRect(),W=box.width;
      this.intro.style.transform='translateX(-50%)';
      const intro=this.intro.getBoundingClientRect();
      const safeTop=intro.bottom-box.top+(m?this.num('introGapM',24):24);
      const slotRects=this.slots.map(s=>s.getBoundingClientRect());
      // Preserve the opening on normal screens. Extremely short opening views use natural flow.
      if(H<300||safeTop>H-100){
        this.staticMode=true;this.resetStatic();return;
      }
      const n=this.active.length, random=rand(this.num('seed',18));
      const ratio=this.num('ratio',.76), maxCard=this.num(m?'cardM':'cardD',m?130:220);
      const bottom=H-(m?120:65), introAvailable=Math.max(80,bottom-safeTop);
      const baseW=Math.min(maxCard,W*(m?.32:.17),introAvailable*.68*ratio), baseH=baseW/ratio;
      const spread=Math.min(W*.56,baseW*1.6);
      const fanRad=this.num('fan',22)*Math.PI/360;
      const openingHalf=Math.max(baseH/2,(baseH*Math.cos(fanRad)+baseW*Math.sin(fanRad))/2);
      const centerY=m?safeTop+openingHalf:safeTop+introAvailable*.54;
      // Phase 2 uses the entire stage above the controls and intentionally covers the text.
      const scatterTop=m?32:42,available=Math.max(80,bottom-scatterTop);
      const desktopBoost=m?1:this.num('scatterBoostD',135)/100;
      const scatterBase=Math.min(maxCard*this.num('scatterScale',140)/100*desktopBoost,W*(m?.42:.34),available*(m?.64:.9)*ratio);
      const mode=this.dataset[m?'layoutM':'layoutD']||'scatter';
      const positions=[];
      const columns=m?2:Math.ceil(n/2), rows=Math.ceil(n/columns);
      // Seeded shuffled cells: naturally scattered, repeatable and bounded.
      const cells=Array.from({length:columns*rows},(_,i)=>i);
      for(let k=cells.length-1;k>0;k--){const j=Math.floor(random()*(k+1));[cells[k],cells[j]]=[cells[j],cells[k]];}
      this.geo=this.active.map((card,i)=>{
        const u=n===1?.5:i/(n-1), stagger=this.num('stagger',30)/100;
        const gapW=(W-40)/columns, gapH=available/rows;
        let w=Math.min(scatterBase,gapW*(m?1.05:1.4),gapH*ratio*(m?.94:1.35)),h=w/ratio;
        let x,y,r=(random()-.5)*this.num('rotation',18);
        if(mode==='orbit'){
          const a=-Math.PI/2+i/n*Math.PI*2;
          w=Math.min(scatterBase,W/(m?3:4.2),available*ratio*(m?.36:.49));h=w/ratio;
          x=W/2+Math.cos(a)*(W/2-w*.7-25);y=scatterTop+available/2+Math.sin(a)*(available/2-h*.65-10);
        }else if(mode==='diagonal'){
          x=25+w/2+(W-w-50)*u;y=scatterTop+h/2+(available-h)*(.2+.6*u)+(i%2?1:-1)*Math.min(35,available*.1);
        }else if(mode==='collage'){
          const col=i%columns,row=Math.floor(i/columns);w*=i%3===0?1.08:.92;h=w/ratio;
          x=20+gapW*(col+.5);y=scatterTop+gapH*(row+.5)+(col%2?1:-1)*Math.min(25,gapH*.12);
        }else if(mode==='custom'){
          x=W*this.blockNum(card,m?'xm':'xd',50)/100;y=scatterTop+available*this.blockNum(card,m?'ym':'yd',50)/100;
          w=Math.min(scatterBase*this.blockNum(card,'scale',100)/100,W*.4,available*ratio*.8);h=w/ratio;r=this.blockNum(card,'rotate',0);
        }else{
          const cell=cells[i],col=cell%columns,row=Math.floor(cell/columns);
          w*=.8+random()*.28;h=w/ratio;x=20+gapW*(col+.5)+(random()-.5)*gapW*.16;y=scatterTop+gapH*(row+.5)+(random()-.5)*gapH*.13;
        }
        // Keep rotated corners within stage bounds; text overlap is allowed in phase 2.
        const rad=Math.abs(r)*Math.PI/180;
        const fit=Math.min(1,(W-24)/(w*Math.cos(rad)+h*Math.sin(rad)),available/(h*Math.cos(rad)+w*Math.sin(rad)));
        w*=fit;h*=fit;
        const rx=(w*Math.cos(rad)+h*Math.sin(rad))/2,ry=(h*Math.cos(rad)+w*Math.sin(rad))/2;
        x=clamp(x,rx+12,W-rx-12);y=clamp(y,scatterTop+ry,bottom-ry);
        const target=slotRects[i];
        const startR=(u-.5)*this.num('fan',22);
        const start={x:W/2+(u-.5)*spread,y:centerY,w:baseW,h:baseH,r:startR};
        const scatter={x,y,w,h,r};
        const end={x:target.left-box.left+target.width/2,y:target.top-box.top+target.height/2,w:target.width,h:target.height,r:0};
        positions.push(scatter);return{card,start,scatter,end,delay:u*stagger*.15};
      });
      this.floor?.configure();
      this.schedule();
    }
    blockNum(card,key,fallback){const v=Number(card.dataset[key]);return Number.isFinite(v)?v:fallback;}
    topOffset(){return parseFloat(getComputedStyle(this).getPropertyValue('--ks-top'))||0;}
    viewportTop(){return this.scroller?this.scroller.getBoundingClientRect().top+this.scroller.clientTop:0;}
    progress(){return clamp((this.viewportTop()+this.topOffset()-this.getBoundingClientRect().top)/Math.max(1,this.travel));}
    paint(){
      if(this.staticMode||!this.geo)return;
      // Keep the stage inside this section's real document space, regardless of ancestor overflow.
      const pin=clamp(this.viewportTop()+this.topOffset()-this.getBoundingClientRect().top,0,this.travel+this.num('exitSpace',60));
      this.stage.style.transform=`translate3d(0,${pin}px,0)`;
      const p=this.focusCard?1:(this.editorP??this.progress());
      const finish=1-this.num('finalHold',18)/100;
      const a=this.num('phaseA',38)/100,b=Math.min(this.num('phaseB',65)/100,finish-.12);
      const t2=ease((p-b)/(finish-b)),move2=ease((t2-.2)/.8);
      const fadeTo=this.num('scatterText',28)/100;
      this.intro.style.opacity=String(mix(1,fadeTo,ease((p-.07)/(a-.07)))*(1-ease(t2/.18)));this.intro.style.visibility=t2>=.18?'hidden':'visible';
      const show=t2>.72; this.final.style.opacity=String(ease((t2-.35)/.65));this.final.style.visibility=t2>.35?'visible':'hidden';
      this.final.toggleAttribute('inert',!show);this.final.setAttribute('aria-hidden',String(!show));
      this.floor?.setVisible(show);
      for(const g of this.geo){
        const first=ease((p-.07-g.delay)/(a-.07-g.delay));
        const v={};for(const key of ['x','y','w','h','r'])v[key]=mix(mix(g.start[key],g.scatter[key],first),g.end[key],move2);
        g.card.style.width=v.w+'px';g.card.style.height=v.h+'px';
        g.card.style.transform=`translate3d(${v.x-v.w/2}px,${v.y-v.h/2}px,0) rotate(${v.r}deg)`;
        g.card.style.zIndex=String(this.geo.indexOf(g)+1);
      }
      this.style.setProperty('--ks-p',p);
      if(this.label)this.label.textContent=p<a?this.dataset.labelOne:p<b?this.dataset.labelTwo:this.dataset.labelThree;
    }
    go(p){
      if(this.staticMode)return;
      const target=p===1?1-this.num('finalHold',18)/100+.015:p;
      this.editorP=null;this.focusCard=false;
      this.scrollByDistance(this.getBoundingClientRect().top-this.viewportTop()-this.topOffset()+target*this.travel);
    }
    scrollByDistance(delta){
      const target=this.scroller||window;
      const current=this.scroller?this.scroller.scrollTop:window.scrollY;
      target.scrollTo({top:Math.max(0,current+delta),behavior:this.reduced.matches?'instant':'smooth'});
    }
    leave(direction){
      this.editorP=null;this.focusCard=false;
      const rect=this.getBoundingClientRect();
      const height=this.scroller?this.scroller.clientHeight:window.innerHeight;
      const delta=direction==='next'?rect.bottom-this.viewportTop()-this.topOffset():rect.top-this.viewportTop()-height+this.topOffset();
      this.scrollByDistance(delta);
    }
  }
  customElements.define('ketfii-scroll-story',KetfiiScrollStory);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ketfii-studio-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('ketfii-studio-footer')) return;
    customElements.define('ketfii-studio-footer', class extends HTMLElement {
      connectedCallback() {
        if (this._abort) return;
        this._abort = new AbortController();
        const signal = this._abort.signal;
        this._media = window.matchMedia('(max-width: 749px)');
        this._toggles = [...this.querySelectorAll('[data-toggle]')];
        this._panels = this._toggles.map(button => this.querySelector('#' + CSS.escape(button.getAttribute('aria-controls'))));
        this._open = new Set();
        if (this.dataset.initialOpen === 'all') this._toggles.forEach((_, i) => this._open.add(i));
        if (this.dataset.initialOpen === 'first' && this._toggles.length) this._open.add(0);
        if (this.dataset.accordionMode === 'single' && this._open.size > 1) this._open = new Set([0]);
        this._refresh = () => {
          this._accordion = this._media.matches && this.dataset.mobileNav === 'accordion';
          this._toggles.forEach((button, i) => {
            const open = !this._accordion || this._open.has(i);
            button.disabled = !this._accordion;
            if (!open && this._panels[i]?.contains(document.activeElement)) button.focus({ preventScroll:true });
            button.setAttribute('aria-expanded', String(open));
            if (this._panels[i]) this._panels[i].hidden = !open;
          });
        };
        this._toggles.forEach((button, i) => button.addEventListener('click', () => {
          if (!this._accordion) return;
          const wasOpen = this._open.has(i);
          if (this.dataset.accordionMode === 'single') this._open.clear();
          if (wasOpen) this._open.delete(i); else this._open.add(i);
          this._refresh();
        }, { signal }));
        this.addEventListener('keydown', event => {
          if (!this._accordion || !event.target.matches('[data-toggle]')) return;
          const index = this._toggles.indexOf(event.target);
          let next;
          if (event.key === 'ArrowDown') next = (index + 1) % this._toggles.length;
          if (event.key === 'ArrowUp') next = (index - 1 + this._toggles.length) % this._toggles.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this._toggles.length - 1;
          if (next !== undefined) { event.preventDefault(); this._toggles[next].focus(); }
        }, { signal });
        if (this._media.addEventListener) this._media.addEventListener('change', this._refresh);
        else this._media.addListener(this._refresh);
        document.addEventListener('shopify:block:select', event => {
          const index = this._toggles.findIndex(button => button.closest('[data-column-id]')?.dataset.columnId === event.detail?.blockId);
          if (index < 0) return;
          if (this.dataset.accordionMode === 'single') this._open.clear();
          this._open.add(index);
          this._refresh();
        }, { signal });
        this.querySelector('[data-back-top]')?.addEventListener('click', event => {
          const main = document.getElementById('MainContent') || document.querySelector('main');
          const wrapper = this.closest('.page-wrapper');
          const scrollParent = wrapper && /auto|scroll/.test(getComputedStyle(wrapper).overflowY) ? wrapper : window;
          if (!scrollParent.scrollTo) return;
          event.preventDefault();
          if (main) {
            if (!main.hasAttribute('tabindex')) { main.setAttribute('tabindex', '-1'); main.addEventListener('blur', () => main.removeAttribute('tabindex'), { once:true }); }
            main.focus({ preventScroll:true });
          }
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduced) {
            const scrollElement = scrollParent === window ? document.documentElement : scrollParent;
            const prior = scrollElement.style.scrollBehavior;
            scrollElement.style.scrollBehavior = 'auto';
            scrollParent.scrollTo({ top:0, behavior:'auto' });
            scrollElement.style.scrollBehavior = prior;
          } else scrollParent.scrollTo({ top:0, behavior:'smooth' });
        }, { signal });
        this._refresh();
        this.dataset.ready = '';
        const form = this.querySelector('.kfsf__form');
        if (form && location.hash === '#' + form.id) form.querySelector('.kfsf__status')?.focus({ preventScroll:true });
      }
      disconnectedCallback() {
        this._abort?.abort();
        this._abort = null;
        if (this._media?.removeEventListener) this._media.removeEventListener('change', this._refresh);
        else this._media?.removeListener(this._refresh);
        delete this.dataset.ready;
        this._toggles?.forEach((button,i) => { button.disabled = true; button.setAttribute('aria-expanded','true'); if (this._panels[i]) this._panels[i].hidden = false; });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ketfii-studio-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ketfii-header')) {
  customElements.define('ketfii-header', class KetfiiHeader extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.frame = this.querySelector('.kh-frame');
      this.space = this.querySelector('.kh-frame-space');
      this.bar = this.querySelector('.kh-bar');
      this.wrapper = this.closest('.shopify-section');
      this.pageWrapper = document.querySelector('.page-wrapper');
      // Tinker scrolls .page-wrapper on desktop; the document scrolls on mobile.
      // This threshold is a theme behavior, independent of the editable menu breakpoint.
      this.scrollMedia = matchMedia('(min-width: 990px)');
      this.drawer = this.querySelector('[data-mobile-drawer]');
      this.toggle = this.querySelector('[data-toggle-mobile]');
      this.scrim = this.querySelector('[data-scrim]');
      this.menus = [...this.querySelectorAll('[data-menu]')];
      this.account = this.querySelector('[data-account]');
      this.searches = [];
      this.cache = new Map();
      this.previousY = this.scrollTop();
      this.media = matchMedia(`(max-width: ${Number(this.dataset.breakpoint) - 1}px)`);
      this.hoverMedia = matchMedia('(hover: hover) and (pointer: fine)');
      this.listen(this.media, 'change', () => this.resize());
      this.listen(this.scrollMedia, 'change', () => { this.previousY = this.scrollTop(); this.resize(); });
      this.listen(window, 'resize', () => this.resize());
      this.listen(window, 'scroll', () => this.queueMeasure(), { passive: true });
      if (this.pageWrapper) this.listen(this.pageWrapper, 'scroll', () => this.queueMeasure(), { passive: true });
      if (window.visualViewport) this.listen(window.visualViewport, 'resize', () => this.queueMeasure());
      this.listen(window, 'pageshow', () => { this.closeAll(); this.resize(); });
      this.listen(this, 'click', event => this.click(event));
      this.listen(this, 'keydown', event => this.keydown(event));
      this.listen(document, 'pointerdown', event => {
        if (!this.contains(event.target)) this.closeAll();
      });
      this.listen(document, 'theme-drawer:open', () => this.closeAll());
      this.listen(document, 'focusin', event => {
        if (!this.contains(event.target) && !this.mobileOpen) this.closeAll();
        else if (!this.mobileOpen) {
          for (const menu of [...this.menus, this.account].filter(Boolean)) {
            if (menu.open && !menu.contains(event.target)) {
              menu.open = false;
              menu.querySelector('summary')?.setAttribute('aria-expanded', 'false');
            }
          }
          this.updateState();
        }
      });
      this.listen(this, 'change', event => {
        if (event.target.matches('[data-localize]')) event.target.form?.requestSubmit();
      });
      for (const details of [...this.menus, this.account].filter(Boolean)) {
        this.listen(details, 'toggle', () => {
          details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open));
          this.updateState();
        });
        this.listen(details, 'pointerenter', event => {
          if (!this.isMobile && this.dataset.hover === 'true' && this.hoverMedia.matches && event.pointerType !== 'touch') {
            clearTimeout(this.hoverTimer);
            this.hoverTimer = setTimeout(() => this.openDetails(details), 120);
          }
        });
        this.listen(details, 'pointerleave', () => {
          clearTimeout(this.hoverTimer);
          if (!this.isMobile && this.hoverMedia.matches && this.dataset.hover === 'true') {
            this.hoverTimer = setTimeout(() => {
              if (!details.contains(document.activeElement)) { details.open = false; this.updateState(); }
            }, 220);
          }
        });
      }
      this.querySelectorAll('[data-search]').forEach(element => this.initSearch(element));
      this.listen(document, 'shopify:block:select', event => this.selectEditorBlock(event));
      this.listen(document, 'shopify:section:unload', event => {
        if (event.detail?.sectionId === this.dataset.sectionId) this.disconnectedCallback();
      });
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.queueMeasure(true));
        this.observer.observe(this.bar);
        this.observer.observe(this.querySelector('.kh-utility') || this.space);
        this.observer.observe(document.querySelector('.page-wrapper') || document.body);
      }
      const count = this.querySelector('[ref="cartBubbleCount"]');
      if (count && 'MutationObserver' in window) {
        const update = () => {
          const value = count.textContent.trim();
          this.querySelector('.kh-cart')?.setAttribute('aria-label', `${this.dataset.cartLabel}${value ? ` (${value})` : ''}`);
        };
        this.cartObserver = new MutationObserver(update);
        this.cartObserver.observe(count, { characterData: true, subtree: true, childList: true });
        update();
      }
      this.resize();
      document.fonts?.ready.then(() => { if (this.isConnected && this.controller) this.resize(); });
    }

    disconnectedCallback() {
      this.closeAll();
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.cartObserver?.disconnect();
      clearTimeout(this.hoverTimer);
      cancelAnimationFrame(this.measureRAF);
      for (const search of this.searches || []) {
        clearTimeout(search.timer);
        search.abort?.abort();
      }
      this.wrapper?.style.removeProperty('margin-bottom');
    }

    listen(target, type, handler, options = {}) {
      target.addEventListener(type, handler, { ...options, signal: this.controller.signal });
    }

    scrollTop() {
      return this.scrollMedia.matches && this.pageWrapper ? this.pageWrapper.scrollTop : window.scrollY;
    }

    resize() {
      // The editable breakpoint is the minimum; exceptionally wide menus also collapse.
      this.classList.remove('is-compact');
      const nav = this.querySelector('.kh-nav--desktop');
      const navItems = nav ? [...nav.children] : [];
      const navGap = nav ? parseFloat(getComputedStyle(nav).columnGap) || 0 : 0;
      const required = navItems.reduce((width, item) => width + item.getBoundingClientRect().width, 0) + navGap * Math.max(0, navItems.length - 1);
      const tooWide = !this.media.matches && nav && (required > nav.clientWidth + 2 || this.bar.scrollWidth > this.bar.clientWidth + 2);
      this.classList.toggle('is-compact', Boolean(tooWide));
      const nextMobile = this.media.matches || Boolean(tooWide);
      if (this.isMobile !== undefined && nextMobile !== this.isMobile) this.closeAll();
      this.isMobile = nextMobile;
      const overlay = this.dataset.overlay === 'true' && (!this.isMobile || this.dataset.overlayMobile === 'true');
      this.frame.toggleAttribute('transparent', overlay);
      this.overlay = overlay;
      this.measure();
    }

    queueMeasure(resize = false) {
      this.needsResize ||= resize;
      if (this.measureRAF) return;
      this.measureRAF = requestAnimationFrame(() => {
        this.measureRAF = 0;
        const resizeNeeded = this.needsResize;
        this.needsResize = false;
        if (resizeNeeded) this.resize(); else this.measure();
      });
    }

    measure() {
      if (!this.controller) return;
      const styles = getComputedStyle(this);
      const gap = parseFloat(styles.getPropertyValue('--kh-gap')) || 0;
      const rowHeight = this.bar.getBoundingClientRect().height;
      const reserve = rowHeight + gap;
      this.space.style.height = `${reserve}px`;
      if (this.wrapper) this.wrapper.style.marginBottom = this.overlay ? `${-reserve}px` : '0px';
      const y = this.scrollTop();
      const threshold = this.space.getBoundingClientRect().top + y + gap;
      const fixed = this.dataset.sticky !== 'none' && y > threshold + 1;
      this.dataset.fixed = String(fixed);
      const delta = y - this.previousY;
      const interacting = this.hasOpenContent() || this.contains(document.activeElement) || this.mobileOpen;
      if (!fixed || interacting || delta < -3) this.dataset.stickyHidden = 'false';
      else if (this.dataset.sticky === 'up' && delta > 3) this.dataset.stickyHidden = 'true';
      this.previousY = y;
      const bounds = this.getBoundingClientRect();
      this.style.setProperty('--kh-fixed-left', `${bounds.left}px`);
      this.style.setProperty('--kh-fixed-width', `${bounds.width}px`);
      const bottom = this.bar.getBoundingClientRect().bottom;
      const viewport = window.visualViewport ? window.visualViewport.height + window.visualViewport.offsetTop : window.innerHeight;
      this.style.setProperty('--kh-bottom', `${Math.max(0, bottom)}px`);
      this.style.setProperty('--kh-panel-max', `${Math.max(100, viewport - bottom - 12)}px`);
      if (document.querySelector('#header-component') === this.frame) {
        document.body.style.setProperty('--header-height', `${reserve}px`);
        const group = document.querySelector('#header-group');
        document.body.style.setProperty('--header-group-height', `${group?.offsetHeight || 0}px`);
        document.body.style.setProperty('--transparent-header-offset-boolean', this.overlay ? '1' : '0');
      }
      this.updateState();
    }

    hasOpenContent() {
      return Boolean(this.menus?.some(menu => menu.open) || this.account?.open || this.searches?.some(search => search.open));
    }

    updateState() {
      const open = this.hasOpenContent() || Boolean(this.mobileOpen);
      this.dataset.solid = String(!this.overlay || this.dataset.fixed === 'true' || open);
      if (this.scrim) this.scrim.hidden = !open;
      if (open) this.dataset.stickyHidden = 'false';
    }

    openDetails(details, focus = false) {
      clearTimeout(this.hoverTimer);
      for (const other of [...this.menus, this.account].filter(Boolean)) {
        other.open = other === details;
        other.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(other.open));
      }
      this.searches.forEach(search => this.hideSearch(search));
      this.updateState();
      this.queueMeasure();
      if (focus) details.querySelector('a, .kh-submenu > summary')?.focus();
    }

    click(event) {
      const toggle = event.target.closest('[data-toggle-mobile]');
      if (toggle) { this.setMobile(!this.mobileOpen); return; }
      if (event.target.closest('[data-open-search]')) {
        this.setMobile(true);
        this.querySelector('[data-scope="mobile"] input[type="search"]')?.focus();
        return;
      }
      if (event.target.closest('[data-scrim]')) { this.closeAll(true); return; }
      const summary = event.target.closest('[data-menu] > summary, [data-account] > summary');
      if (summary) {
        event.preventDefault();
        const details = summary.parentElement;
        if (details.open) {
          details.open = false;
          summary.setAttribute('aria-expanded', 'false');
          this.updateState();
        } else this.openDetails(details);
        return;
      }
      const cart = event.target.closest('[data-cart]');
      if (cart && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
        const drawer = document.querySelector('#cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          event.preventDefault();
          this.closeAll();
          this.querySelector('.kh-cart')?.focus();
          drawer.open();
        }
        return;
      }
      if (event.target.closest('a')) this.closeAll();
    }

    visible(element) {
      return !element.closest('[hidden], [inert]') && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    }

    keydown(event) {
      if (event.defaultPrevented) return;
      if (event.key === 'Escape') {
        const nested = event.target.closest('.kh-submenu[open]');
        if (nested) { event.preventDefault(); nested.open = false; nested.querySelector('summary').focus(); return; }
        const details = [...this.menus, this.account].filter(Boolean).find(menu => menu.open && menu.contains(event.target));
        if (details) { event.preventDefault(); details.open = false; details.querySelector('summary').focus(); this.updateState(); return; }
        if (this.hasOpenContent() || this.mobileOpen) { event.preventDefault(); this.closeAll(true); }
        return;
      }
      const summary = event.target.closest('[data-menu] > summary, [data-account] > summary');
      if (summary && event.key === 'ArrowDown') {
        event.preventDefault(); this.openDetails(summary.parentElement, true); return;
      }
      if (!this.isMobile && summary && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        const controls = [...this.querySelectorAll('.kh-nav--desktop .kh-trigger')];
        const current = controls.indexOf(summary);
        if (current < 0) return;
        event.preventDefault();
        let next = event.key === 'Home' ? 0 : event.key === 'End' ? controls.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1);
        controls[(next + controls.length) % controls.length]?.focus();
        return;
      }
      if (event.key === 'Tab' && this.mobileOpen) {
        const focusable = [...this.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), summary, select')].filter(el => this.visible(el));
        const first = focusable[0], last = focusable.at(-1);
        if (event.shiftKey && (document.activeElement === first || !this.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
    }

    setMobile(open, restore = false) {
      if (open && !this.isMobile) return;
      if (Boolean(this.mobileOpen) === open) return;
      this.mobileOpen = open;
      this.dataset.mobileOpen = String(open);
      this.toggle.setAttribute('aria-expanded', String(open));
      this.drawer.hidden = !open;
      if (open) {
        this.returnFocus = document.activeElement;
        this.savedOverflow = document.documentElement.style.overflow;
        this.savedWrapperOverflow = this.pageWrapper?.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        if (this.pageWrapper) this.pageWrapper.style.overflow = 'hidden';
        this.setAttribute('role', 'dialog');
        this.setAttribute('aria-modal', 'true');
        this.setAttribute('aria-label', this.toggle.getAttribute('aria-label'));
        this.inertElements = [...document.querySelectorAll('main, .page-wrapper > footer, #header-group > .shopify-section')]
          .filter(el => !el.contains(this)).map(el => ({ el, value: el.inert }));
        this.inertElements.forEach(({ el }) => { el.inert = true; });
        this.querySelector('[data-scope="mobile"] input[type="search"], .kh-nav--mobile .kh-trigger')?.focus();
      } else {
        document.documentElement.style.overflow = this.savedOverflow ?? '';
        if (this.pageWrapper) this.pageWrapper.style.overflow = this.savedWrapperOverflow ?? '';
        this.inertElements?.forEach(({ el, value }) => { el.inert = value; });
        this.inertElements = [];
        this.removeAttribute('role');
        this.removeAttribute('aria-modal');
        this.removeAttribute('aria-label');
        if (restore) (this.returnFocus?.isConnected ? this.returnFocus : this.toggle)?.focus();
      }
      this.updateState();
      this.queueMeasure();
    }

    closeAll(restore = false) {
      clearTimeout(this.hoverTimer);
      const wasMobile = this.mobileOpen;
      const restoreControl = [...(this.menus || []), this.account].filter(Boolean).find(menu => menu.open)?.querySelector('summary') || this.searches?.find(search => search.open)?.input;
      for (const menu of [...(this.menus || []), this.account].filter(Boolean)) {
        menu.open = false;
        menu.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
      }
      this.searches?.forEach(search => this.hideSearch(search));
      if (this.mobileOpen) this.setMobile(false, restore);
      else if (restore && !wasMobile) restoreControl?.focus();
      this.updateState();
    }

    initSearch(element) {
      const search = {
        element, input: element.querySelector('input[type="search"]'), clear: element.querySelector('[data-clear]'),
        results: element.querySelector('[data-results]'), list: element.querySelector('[data-result-list]'),
        status: element.querySelector('[data-status]'), all: element.querySelector('[data-search-all]'),
        seq: 0, selected: -1, open: false
      };
      this.searches.push(search);
      this.listen(search.input, 'input', () => {
        search.clear.hidden = !search.input.value;
        search.abort?.abort();
        clearTimeout(search.timer);
        search.seq++;
        search.selected = -1;
        search.input.removeAttribute('aria-activedescendant');
        if (!search.results) return;
        const query = search.input.value.trim();
        if (query.length < Number(this.dataset.searchMin)) { this.hideSearch(search); return; }
        // Remove stale options immediately; they must never be submitted for the next query.
        search.list.replaceChildren();
        this.showSearch(search);
        search.status.textContent = this.dataset.loadingLabel;
        search.all.href = this.searchUrl(query);
        search.timer = setTimeout(() => this.fetchSearch(search, query), 200);
      });
      this.listen(search.input, 'focus', () => {
        if (search.skipFocus) { search.skipFocus = false; return; }
        const query = search.input.value.trim();
        if (search.results && query.length >= Number(this.dataset.searchMin)) this.fetchSearch(search, query);
      });
      this.listen(search.clear, 'click', () => {
        search.input.value = '';
        search.clear.hidden = true;
        this.hideSearch(search);
        search.input.focus();
      });
      this.listen(element, 'keydown', event => {
        if (!search.open) return;
        if (event.key === 'Escape') {
          event.preventDefault(); event.stopPropagation(); this.hideSearch(search);
          if (document.activeElement !== search.input) { search.skipFocus = true; search.input.focus(); }
          return;
        }
        if (event.target !== search.input) return;
        const options = [...search.list.querySelectorAll('[role="option"]')];
        if (['ArrowDown', 'ArrowUp'].includes(event.key) && options.length) {
          event.preventDefault();
          search.selected = (search.selected + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
          options.forEach((option, i) => option.setAttribute('aria-selected', String(i === search.selected)));
          const option = options[search.selected];
          search.input.setAttribute('aria-activedescendant', option.id);
          option.scrollIntoView({ block: 'nearest' });
        } else if (event.key === 'Enter' && search.selected >= 0 && options[search.selected]) {
          event.preventDefault();
          options[search.selected].click();
        }
      });
      this.listen(element.querySelector('form'), 'submit', () => this.closeAll());
    }

    searchUrl(query) {
      const url = new URL(this.dataset.searchUrl, location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('options[prefix]', 'last');
      return url.href;
    }

    showSearch(search) {
      for (const menu of [...this.menus, this.account].filter(Boolean)) {
        menu.open = false;
        menu.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
      }
      this.searches.filter(other => other !== search).forEach(other => this.hideSearch(other));
      search.open = true;
      search.results.hidden = false;
      search.input.setAttribute('aria-expanded', 'true');
      this.updateState();
    }

    hideSearch(search) {
      clearTimeout(search.timer);
      search.abort?.abort();
      search.seq++;
      search.open = false;
      search.selected = -1;
      if (search.results) search.results.hidden = true;
      if (search.input.hasAttribute('role')) search.input.setAttribute('aria-expanded', 'false');
      search.input.removeAttribute('aria-activedescendant');
      this.updateState();
    }

    async fetchSearch(search, query) {
      search.abort?.abort();
      const seq = ++search.seq;
      search.abort = new AbortController();
      this.showSearch(search);
      search.status.textContent = this.dataset.loadingLabel;
      search.all.href = this.searchUrl(query);
      try {
        let data = this.cache.get(query);
        if (!data) {
          const url = new URL(this.dataset.suggestUrl, location.origin);
          url.pathname = url.pathname.replace(/\.json$/, '') + '.json';
          url.searchParams.set('q', query);
          url.searchParams.set('resources[type]', this.dataset.searchTypes);
          url.searchParams.set('resources[limit]', this.dataset.searchLimit);
          url.searchParams.set('resources[limit_scope]', 'all');
          url.searchParams.set('resources[options][unavailable_products]', 'last');
          const response = await fetch(url.href, { signal: search.abort.signal, credentials: 'same-origin', headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Search unavailable');
          data = await response.json();
          if (seq !== search.seq) return;
          if (this.cache.size > 24) this.cache.delete(this.cache.keys().next().value);
          this.cache.set(query, data);
        }
        if (seq !== search.seq || !search.open || search.input.value.trim() !== query) return;
        this.renderResults(search, data, query);
      } catch (error) {
        if (error.name === 'AbortError' || seq !== search.seq) return;
        search.list.replaceChildren();
        search.status.textContent = this.dataset.errorLabel;
        // The normal GET search form and full-results link remain available.
      }
    }

    safeUrl(value, image = false) {
      if (typeof value !== 'string' || !value) return null;
      try {
        const url = new URL(value, location.origin);
        if (!['https:', 'http:'].includes(url.protocol)) return null;
        return image || url.origin === location.origin ? url.href : null;
      } catch { return null; }
    }

    renderResults(search, data, query) {
      const results = data?.resources?.results || {};
      const entries = ['queries', 'products', 'collections', 'pages', 'articles']
        .flatMap(type => (Array.isArray(results[type]) ? results[type] : []).map(item => ({ type, item })))
        .slice(0, Number(this.dataset.searchLimit));
      const fragment = document.createDocumentFragment();
      let count = 0;
      for (const { type, item } of entries) {
        const title = item.title || item.text;
        if (!title) continue;
        const href = this.safeUrl(item.url) || (type === 'queries' ? this.searchUrl(item.text || query) : null);
        if (!href) continue;
        const option = document.createElement('a');
        option.className = 'kh-result';
        option.href = href;
        option.id = `${search.list.id}-option-${count++}`;
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', 'false');
        option.tabIndex = 0;
        const image = this.safeUrl(item.featured_image?.url || item.image, true);
        if (image) {
          const img = document.createElement('img');
          img.src = image; img.alt = ''; img.width = 60; img.height = 60; img.loading = 'lazy';
          option.append(img);
        }
        const copy = document.createElement('span'); copy.className = 'kh-result-copy';
        const name = document.createElement('span'); name.className = 'kh-result-title'; name.textContent = title;
        copy.append(name);
        if (type === 'products' && this.dataset.showPrice === 'true' && item.price !== undefined && Number.isFinite(Number(item.price))) {
          const price = document.createElement('span'); price.className = 'kh-result-price';
          try { price.textContent = new Intl.NumberFormat(this.dataset.locale || undefined, { style: 'currency', currency: this.dataset.currency }).format(Number(item.price)); }
          catch { price.textContent = `${item.price} ${this.dataset.currency}`; }
          copy.append(price);
        }
        option.append(copy);
        fragment.append(option);
      }
      search.list.replaceChildren(fragment);
      search.selected = -1;
      search.input.removeAttribute('aria-activedescendant');
      search.status.textContent = count ? `${this.dataset.resultsLabel} (${count})` : this.dataset.emptyLabel;
    }

    selectEditorBlock(event) {
      if (!this.contains(event.target) && event.detail?.sectionId !== this.dataset.sectionId) return;
      const id = event.detail?.blockId;
      const scope = this.isMobile ? '.kh-nav--mobile' : '.kh-nav--desktop';
      const target = [...this.querySelectorAll(`${scope} [data-block-id]`)].find(element => element.dataset.blockId === id);
      if (!target) return;
      if (this.isMobile) this.setMobile(true);
      const details = target.closest('[data-menu]') || target.querySelector('[data-menu]');
      if (details) this.openDetails(details);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ketfii-warm-newsletter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('ketfii-warm-newsletter')) return;
    customElements.define('ketfii-warm-newsletter', class extends HTMLElement {
      connectedCallback() {
        if (this._abort || this.dataset.motion !== 'true') return;
        this._button = this.querySelector('[data-motion-toggle]');
        this._art = this.querySelector('.kwarm__art');
        if (!this._art) return;
        this._abort = new AbortController();
        const signal = this._abort.signal;
        this._reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        this._mobile = window.matchMedia('(max-width: 749px)');
        this._visible = false;
        this._paused = this._button ? Boolean(this._paused) : false;
        this._sync = () => {
          const artHidden = this.classList.contains(this._mobile.matches ? 'kwarm--hide-art-mobile' : 'kwarm--hide-art-desktop');
          const enabled = !this._reduce.matches && !artHidden;
          this.toggleAttribute('data-playing', enabled && this._visible && !this._paused && !document.hidden);
          if (this._button) {
            this._button.hidden = !enabled || !this._observer;
            this._button.setAttribute('aria-pressed', String(this._paused));
            const label = this._paused ? this.dataset.playLabel : this.dataset.pauseLabel;
            this._button.setAttribute('aria-label', label);
            this._button.title = label;
          }
        };
        this._button?.addEventListener('click', () => { this._paused = !this._paused; this._sync(); }, { signal });
        document.addEventListener('visibilitychange', this._sync, { signal });
        for (const media of [this._reduce, this._mobile]) {
          if (media.addEventListener) media.addEventListener('change', this._sync);
          else media.addListener(this._sync);
        }
        if ('IntersectionObserver' in window) {
          this._observer = new IntersectionObserver(entries => {
            this._visible = entries.some(entry => entry.isIntersecting);
            this._sync();
          }, { threshold:0 });
          this._observer.observe(this);
        }
        this._sync();
      }
      disconnectedCallback() {
        this._abort?.abort(); this._abort = null;
        this._observer?.disconnect(); this._observer = null;
        for (const media of [this._reduce, this._mobile]) {
          if (media?.removeEventListener) media.removeEventListener('change', this._sync);
          else media?.removeListener(this._sync);
        }
        this.removeAttribute('data-playing');
        if (this._button) this._button.hidden = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
